/**
 * @file
 * Language: Portuguese Brazil
 */
export default {
  lang: {
    code: 'pt-BR',
    name: 'Português',
    decimal: ',',
    thousands: '.',
  },

  currency: {
    USD: {
      prefix: 'USD$',
      precision: '2',
    },
    BRL: {
      prefix: 'R$',
      precision: '2',
    },
  },

  country: {
    BRA: {
      name: 'Brasil',
      alpha2: 'BR',
      alpha3: 'BRA',
      lang: {
        code: 'pt-BR',
        name: 'Português',
      },
    },

    USA: {
      name: 'Estados Unidos',
      alpha2: 'US',
      alpha3: 'USA',
      lang: {
        code: 'en-US',
        name: 'Inglês',
      },
    },
  },

  system: {
    question: {
      confirmRemove: 'Tem certeza que deseja remover este item?',
    },
    info: {
      welcome: 'Bem-vindo',
      pleaseWait: 'Aguarde, isso pode levar um tempo...',
      copiedToClipboard: 'Copiado para área de transferência',
      deliveryWithError: '{0} entrega(s) com erro',
      deliverySuccessfullySaved: '{0} entrega(s) salva(s) com sucesso',
      driversSuccessfullySaved: 'Salvo com sucesso',
      deliveryIgnored:
        '{0} entrega(s) ignoradas, pois já existem cargas iniciadas com a mesma danfe',
      noNewFilesSent: 'Nenhum novo arquivo enviado',
      cieloFileDetected: 'Arquivo CIELO detectado',
      pleaseWaitForReport:
        'Por favor aguarde. Seu relatório em breve estará disponível em relatórios gerados.',
      pleaseWaitForImport:
          'Por favor aguarde. Seu arquivo será processado e em breve as informações serão atualizadas.',
      importUnavailableCarga: 'Há um processamento em andamento de um cadastro de carga em lote',
      importUnavailableSla: 'Há um processamento em andamento de um cadastro de SLA',
      importSlaError: 'Não foi possível processar o arquivo de Tabela SLA. Erro: {val}',
      importDeliveryError: 'Não foi possível processar o arquivo de Cadastro em lote. Erro: {val}',
      importError: 'Erro na importação',
      importSuccess: 'Sucesso na importação',
      deliveryWithErrorQuantity: 'Existe(m) {0} entrega(s) com erros',
      deliveryWithErrorReason: 'Motivo: {0}',
    },
    success: {
      resetPassword: 'Um e-mail foi enviado à sua conta',
      recoverPassword: 'Senha alterada com sucesso',
      persist: 'Salvo com sucesso!',
      finish: 'Finalizado com sucesso!',
      remove: 'Removido com sucesso!',
      associate: 'Associado com sucesso!',
      report:
        'Seu relatório está pronto para ser baixado em relatórios gerados',
      sla: 'O arquivo foi processado com sucesso e está disponível em Tabela SLA',
      cargaLote: 'O arquivo foi processado com sucesso e está disponível em Cadastro em Lote',
    },
    error: {
      unauthorized: 'Acesso Restrito',
      noServer: 'Não foi possível conectar ao servidor',
      validation: 'Erro de validação',
      required: 'Campo \'{0}\' é obrigatório',
      invalidEmail: 'Campo \'{0}\' deve ser um e-mail',
      invalidDate: 'Campo \'{0}\' não possui data válida',
      passwordLength: 'A senha deve ter entre {0} e {1} caracteres',
      samePassword: 'Os campos senha devem ser iguais',
      length: 'Campo \'{0}\' deve ter entre {1} e {2} caracteres',
      minLength: 'Campo \'{0}\' deve conter pelo menos {1} caracteres',
      maxLength: 'Campo \'{0}\' deve ter no máximo {1} caracteres',
      min: 'Campo \'{0}\' deve ser no mínimo {1}',
      max: 'Campo \'{0}\' deve ser no máximo {1}',
      invalidAlpha: 'Campo \'{0}\' deve conter apenas letras',
      invalidAlphanumeric: 'Campo \'{0}\' deve conter apenas letras e números',
      invalidCreditCard: 'Número de cartão de crédito inválido',
      format: 'Campo \'{0}\' está com a formatação errada',
      phoneFormat: 'O número de telefone está com a formatação errada',
      zipcodeFormat: 'O CEP está com a formatação errada',
      rgFormat: 'O RG está com a formatação errada',
      cpfFormat: 'O CPF está com a formatação errada',
      cnpjFormat: 'O CNPJ está com a formatação errada',
      noFileSelected: 'Nenhum arquivo selecionado',
      fileNotCompressed: 'Aguarde o arquivo ser interamente comprimindo',
      denied: 'Acesso negado',
      compressing: 'Comprimindo...',
      fileSend: 'Erro no envio do arquivo',
      minSize: 'Arquivo não ultrapassou o tamanho mínimo',
      maxSize: 'Arquivo ultrapassou o tamanho máximo de 5MB',
      nfsInvalidFormat: 'Não há NFs para serem lidas',
      fileInvalidFormat: 'Arquivo com formato inválido',
      fileAllLineError:
        'Erro nos dados no arquivo. Não foi possivel salvar nenhuma linha.',
      passwordsDontMatch: 'As senhas não estão iguais',
      geocode: 'Erro na obtenção da latitude e longitude',
      invalidAddress: 'Endereço inválido: {address}',
      contactAdmin: 'Se o erro persistir, contate o administrador',
      wrongFormat: 'Formato inválido',
      danfeInvalidDocument: 'Informe o CPF/CNPJ do destinatário',
      invalidIdCarga: 'ID de carga inválida na linha #{0}',
      idCargaNotFound:
        'ID de carga não encontrada na base na linha #{0}. Verifique se a carga foi excluída.',
      cargaNotFound:
        'Carga não encontrada na base na linha #{0}. Verifique se a carga foi excluída.',
      idStatusNotPending: 'Carga já está em andamento na linha #{0}',
      invaliDateFormat: 'Data com formato inválido na linha #{0}',
      invalidPrevisaoEntregaFormat: 'Previsão da Entrega está com o formato inválido na linha #{0}',
      invaliDateUpdatedForecastFormat: 'Previsão Atualizada com formato inválido na linha #{0}',
      emptyDateUpdatedForecast: 'Previsão Atualizada não pode ser vazia na linha #{0}',
      datePastFromLine: 'A data está definida no passado na linha #{0}',
      datePastFromLinePrevisaoEntrega: 'Previsão da Entrega está definida no passado na linha #{0}',
      dateUpdatedForecastPastFromLine: 'Previsão Atualizada está definida no passado na linha #{0}',
      dateInTheFutureAtLine: 'A data está definida no futuro na linha #{0}',
      birthDateInvalid: 'Linha {0}: Data de nascimento inválida',
      birthDateEmpty: 'Linha {0}: Data de nascimento não pode ser vazio',
      invalidNroNotaFiscal: 'Número de Nota Fiscal inválido na linha #{0}',
      invalidXpedido: 'Número de Pedido inválido na linha #{0}',
      statusFieldCantBeEmpty: 'O campo de Status não pode ser vazio.',
      invalidField: 'Campo inválido. Complete a informação.',
      incompleteCnpj: 'CNPJ incompleto. Complete os 5 primeiros dígitos.',
      emptyObservation: 'Descrição/Motivo previsão não pode ser vazia na linha #{0}',
      emptyDay: 'Dia não pode ser vazio',
      emptyMonth: 'Mês não pode ser vazio',
      deliveryStatusFinishedExpectedDate:
          'Previsão de entrega não pode ser alterada pois a entrega está finalizada na linha #{0}',
    },
  },

  app: {
    title: 'iTrack',
    subtitle: 'Portal do Cliente',
    iTrackLog: 'iTrack Log',
    itrackPortal: '',
    itrackMobileApp: 'Aplicativo iTrack',
    logout: 'Desconectar',
    menu: 'Menu',
    view: 'Visualizar',
    add: 'Cadastrar',
    next: 'Próximo',
    previous: 'Anterior',
    back: 'Voltar',
    export: 'Exportar',
    select: 'Selecione',
    remove: 'Remover',
    update: 'Atualizar',
    send: 'Enviar',
    save: 'Salvar',
    change: 'Alterar',
    finish: 'Finalizar',
    filter: 'Filtre por:',
    consult: 'Consultar',
    close: 'Fechar',
    cancel: 'Cancelar',
    dismiss: 'Ok',
    associate: 'Associar',
    disassociate: 'Desassociar',
    all: 'Todos',
    nenhum: 'Nenhum',
    or: 'OU',
    of: 'de',
    cleanNFs: 'Limpar notas',
    cleanCTE: 'Limpar CTE',
    filterByMember: 'Filtrar por filial',
    receipt: 'Comprovante',
    download: 'Download',
    edit: 'Editar',
    allowNotification: 'Permitir notificações',
    updateAutomatically: 'Atualizar automaticamente',
    track: 'Rastrear',
    readyToUpload: 'Pronto para upload',
    noDataToShow: 'Nenhum dado para apresentar',
    downloadCsv: 'Baixar CSV',
    search: 'Buscar',
    submit: 'Enviar',
    totalLines: '{total} entradas no total',
    version: 'Versão',
    onlyIfWantChangePassword:
      'Preencha este campo somente se quiser alterar a senha',
    emptyList: 'Lista vazia',
    noResultFound: 'Nenhum resultado encontrado',
    clickToCopy: 'CLIQUE PARA COPIAR',
    selected: 'selecionado|selecionados',
    addFiles: 'Adicionar arquivos',
    dragFiles: 'Arraste os arquivos aqui',
    approved: 'Conforme',
    decline: 'Não Conforme',
    notIdentified: 'Não identificado',
    maskForExportDocument: '00.000.000/0000-00',
    notInformed: 'Não informado',
    pendingDelivery: 'Carga pendente',
    zipcodeNotLocatedByGoogle: 'CEP não localizado no Google',
    previouslyUploadedFile: 'Arquivo enviado previamente',
    imageUnavailable: 'Imagem Indisponível',
    day: 'dia|dias',
    checkboxReplicarCTE:
      'Submeter imagens para as cargas selecionadas com o mesmo CTE',
    selectToLoad: 'Selecione uma busca',
    notify: 'Notificar',
    prioritize: 'Priorizar',
    audit: 'Auditoria',
  },

  dateFormat: {
    date: 'DD/MM/YYYY',
    datetime: 'DD/MM/YYYY HH:mm',
    monthText: 'MMMM',
    monthYear: 'MMMM-YYYY',
    datetimeWithZone: 'DD/MM/YYYY HH:mm (Z)',
    datetimeSecondsWithZone: 'DD/MM/YYYY HH:mm:ssZ',
    inputdate: 'YYYY-MM-DD',
    inputdateAlt: 'DD-MM-YYYY',
    inputdatetimeAlt: 'DD-MM-YYYY HH:mm',
    time: 'HH:mm',
    datemask: '##/##/####',
    datetimemask: '##/##/#### ##:##',
  },

  format: {
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    danfe: '#### #### #### #### #### #### #### #### #### #### ####',
    rg: '##.###.###-#',
    cep: '#####-###',
    phone: '(##) ####-####',
    phoneAlt: '(##) #####-####',
    rgNoFormat: '###############',
  },

  filter: {
    phone: {
      regex: '(\\d{2})(\\d{4,5})(\\d{4})$',
      format: '($1) $2-$3',
    },
    cep: {
      regex: '(\\d{5})(\\d{3})$',
      format: '$1-$2',
    },
  },

  boolean: {
    true: 'Sim',
    false: 'Não',
  },

  httpResponse: {
    100: 'Continue',
    101: 'Switching Protocol',
    200: 'Ok',
    201: 'Created',
    202: 'Accepted',
    203: 'Non Authoritative Information',
    204: 'No Content',
    205: 'Reset Content',
    206: 'Partial Content',
    300: 'Multiple Choices',
    301: 'Moved Permanently',
    302: 'Found',
    303: 'See Other',
    304: 'Not Modified',
    305: 'Use Proxy',
    307: 'Temporary Redirect',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Timeout',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Request Entity Too Large',
    414: 'Request URI Too Long',
    415: 'Unsupported Media Type',
    416: 'Requested Range Not Satisfiable',
    417: 'Expectation Failed',
    422: 'Unprocessable Entity',
    429: 'Too Many Requests',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'Http Version Not Supported',
  },

  navbar: {
    home: 'Home',
  },

  menu: {
    dashboard: 'Dashboard',
    cockpit: 'Cockpit',
    tracking: 'Rastreamento',
    deliveryList: 'Lista de Entregas/Coletas',
    help: 'Ajuda',
    manage: {
      title: 'Administrar',
      deliveryDriver: 'Associar Entregas/Cargas ao Entregador',
      deliveryRegister: 'Cadastro de Entregas/Coletas',
      deliveryEnd: 'Baixar Entregas/Coletas',
      userList: 'Associar CNPJ ao cadastro',
      driverList: 'Entregadores',
      driverTranshipmentList: 'Transbordo',
      occurrenceTypeList: 'Tipo de Ocorrência',
      personTypeList: 'Tipo de Pessoa Recebedor',
      alertList: 'Tipo de Alerta',
      occurrenceSucessTypeList: 'Tipo de finalização com sucesso',
      checkListEntrega: 'Configurar Checklist',
      cnpjBulk: 'CNPJ não integrado WebApi',
      secondaryUserList: 'Cadastro de Usuários',
      auditReasonList: 'Motivos para auditoria',
      settings: 'Configurações',
      smsNotificationsSettings: 'Configurações de SMS',
      emailNotificationsSettings: 'Configurações de E-mail',
      whatsappNotificationsSettings: 'Configurações de Whatsapp',
      rotasSla: 'Tabela SLA',
      addresseeEmail: 'Lista de E-Mails',
      hideResponsavelNotas: 'Ocultar Notas do Transportador',
      auditEmail: 'E-mail Auditoria',
      awaitingAuditCorrection: 'Aguardando Correção de Auditoria',
      awaitingAuditValidation: 'Aguardando Validação de Auditoria',
      riskArea: 'Cadastro Área de Risco',
      securityChecklist: 'Configurar Checklist de Segurança',
      countersign: 'Lista Contra Senha',
      alertDelayedNotasEmail: 'Configurar Alerta de Nota em Atraso',
    },
    reports: {
      title: 'Indicadores',
      deliveryIssue: 'Devoluções e Ocorrências',
      deliveryReceiver: 'Entregas por Destinatário',
      deliveryShipper: 'Entregas por Embarcador/Transportador',
      deliveryDriver: 'Entregas por Entregador',
      deliveryMonth: 'Entregas por Mês',
      deliveryPeriod: 'Entregas por Período',
      deliveryVehicle: 'Entregas por Tipo Veículo',
      deliveryUf: 'Entregas por UF',
      deliveryCanceled: 'Entregas Canceladas',
      deliveryAlertHistory: 'Alertas de Trajeto',
      deliverySatisfactionSurveyHistory: 'Pesquisa de Satisfação',
      deliveryTracking: 'Jornada do Entregador',
      deliveryAudit: 'Auditoria por Geoposicionamento',
      deliverySla: 'SLA',
      deliveryEnded: 'Analíticos de Entregas',
      deliveryMovement: 'Movimentação',
      deliveryChecklist: 'Analítico Checklist',
      deliverySac: 'Tracking (SAC)',
      deliverySacPublic: 'Portal de atendimento de pedidos',
      fragmentDinamicEmptyList:
        'Consultas disponíveis somente para documentos com emissão a partir de ',
      relatorioGeracaoList: 'Relatórios Gerados',
      reportIRoute: 'IRoute',
      riskArea: 'Área de Risco',
      deliverySecurityChecklist: 'Analítico Checklist de Segurança',
      auditByDelivery: 'Auditoria Entrega',
      clientNotification: 'Notificação do cliente',
    },
    logOut: 'Log Out',
  },

  enums: {
    Audit: {
      ACCORDING: 'Conforme',
      NOT_COMPLIANT: 'Não conforme',
    },
    Role: {
      RESPONSAVEL: 'Conta principal',
      RESPONSAVEL_GROUP_MASTER: 'Master',
      RESPONSAVEL_GROUP: 'Grupo econômico',
      RESPONSAVEL_CHILD: 'Conta associado',
      RESPONSAVEL_VIEWER: 'Somente Consulta',
      VIEWER: 'Somente Consulta',
      ASSOCIATE: 'Modo associado',
      SAC: 'SAC',
      GUEST: 'Visitante',
    },
    DeliveryAudit: {
      APPROVED: 'Conforme',
      DISAPPROVED: 'Não conforme',
      UNAUDITED: 'Não auditado',
    },
    DeliveryAuditGeo: {
      APPROVED: 'Conforme',
      DISAPPROVED: 'Não conforme',
    },
    DeliveryDriverStatus: {
      WITH_DRIVER: 'Com entregador',
      WITHOUT_DRIVER: 'Sem entregador',
    },
    DeliveryEvent: {
      OCCURRENCE: 'Com ocorrência',
      NO_OCCURRENCE: 'Sem ocorrência',
      RETURNED: 'Devolvido',
      OCCURRENCE_AND_RETURNED: 'Com ocorrência e devolvido',
    },
    DeliverySlaStatus: {
      NOT_INFORMED: 'Não informado',
      SLA_IN: 'No prazo',
      SLA_OUT: 'Fora do prazo',
    },
    DeliveryStatus: {
      PENDING: 'Pendente',
      STARTED: 'Iniciado',
      FINISHED: 'Finalizado',
    },
    Period: {
      YEARLY: 'Anual',
      MONTHLY: 'Do ano',
      WEEKLY: 'Semanal',
      DAILY: 'Do mês',
      HOURLY: 'Do dia',
      MINUTELY: 'Cada instante',
    },
    GroupBy: {
      VAZIO: 'Nenhum',
      ID_CARGA: 'NF',
      CTE: 'CTE',
    },
     GroupByNoDefault: {
         ID_CARGA: 'NF',
         CTE: 'CTE',
     },
    Transhipment: {
      DELIVERY: 'Pode transbordar',
      RECEIPT: 'Pode receber transbordo',
      DELIVERY_AND_RECEIPT: 'Ambos',
    },
    UF: {
      ACRE: 'Acre',
      ALAGOAS: 'Alagoas',
      AMAPA: 'Amapá',
      AMAZONAS: 'Amazônas',
      BAHIA: 'Bahia',
      CEARA: 'Ceará',
      DISTRITO_FEDERAL: 'Distrito Federal',
      ESPIRITO_SANTO: 'Espírito Santo',
      GOIAS: 'Goiás',
      MARANHAO: 'Maranhão',
      MATO_GROSSO: 'Mato Grosso',
      MATO_GROSSO_DO_SUL: 'Mato Grosso do Sul',
      MINAS_GERAIS: 'Minas Gerais',
      PARA: 'Pará',
      PARAIBA: 'Paraíba',
      PARANA: 'Paraná',
      PERNAMBUCO: 'Pernambuco',
      PIAUI: 'Piauí',
      RIO_DE_JANEIRO: 'Rio de Janeiro',
      RIO_GRANDE_DO_NORTE: 'Rio Grande do Norte',
      RIO_GRANDE_DO_SUL: 'Rio Grande do Sul',
      RONDONIA: 'Rondônia',
      RORAIMA: 'Roraima',
      SANTA_CATARINA: 'Santa Catarina',
      SAO_PAULO: 'São Paulo',
      SERGIPE: 'Sergipe',
      TOCANTINS: 'Tocantins',
    },
    UFInitial: {
      AC: 'Acre',
      AL: 'Alagoas',
      AP: 'Amapá',
      AM: 'Amazônas',
      BA: 'Bahia',
      CE: 'Ceará',
      DF: 'Distrito Federal',
      ES: 'Espírito Santo',
      GO: 'Goiás',
      MA: 'Maranhão',
      MT: 'Mato Grosso',
      MS: 'Mato Grosso do Sul',
      MG: 'Minas Gerais',
      PA: 'Pará',
      PB: 'Paraíba',
      PR: 'Paraná',
      PE: 'Pernambuco',
      PI: 'Piauí',
      RJ: 'Rio de Janeiro',
      RN: 'Rio Grande do Norte',
      RS: 'Rio Grande do Sul',
      RO: 'Rondônia',
      RR: 'Roraima',
      SC: 'Santa Catarina',
      SP: 'São Paulo',
      SE: 'Sergipe',
      TO: 'Tocantins',
    },
    TipoSistema: {
      APP_MOTORISTA: 'App motorista',
      PORTAL_CLIENTE: 'Portal do Cliente',
      INTEGRACAO: 'Integração',
    },
    Region: {
      CENTRO_OESTE: 'Centro Oeste',
      NORDESTE: 'Nordeste',
      NORTE: 'Norte',
      SUDESTE: 'Sudeste',
      SUL: 'Sul',
    },
    SacFilterType: {
      NF: 'Número de Nota Fiscal',
      CTE: 'Chave do CTe (44 dígitos)',
      CORREIO: 'Cód. Rastreamento Correios (13 dígitos)',
      PEDIDO: 'Número do Pedido da Compra',
      DOC: 'CPF/CNPJ do destinatário',
      DANFE: 'Número da Danfe (44 dígitos)',
      DATA_CRIACAO: 'Data de Inclusão',
    },
    SacConcreservFilterType: {
      PEDIDO: 'Número do pedido',
      REMESSA: 'Número da remessa',
    },
    SacBostonFilterType: {
      NF: 'Número de Nota Fiscal',
    },
    TipoVeiculo: {
      BITREM: 'BITREM',
      BITRENZAO: 'BITRENZÃO (9 EIXOS)',
      BITRUCK: 'BI-TRUCK',
      CARRETA: 'CARRETA',
      CARRETA_LS: 'CARRETA LS',
      MOTO: 'MOTO',
      RODOTREM: 'RODOTREM',
      SO_CAVALO_MECANICO_4X2: 'SÓ CAVALO MECANICO (4X2)',
      SO_CAVALO_MECANICO_LS: 'SÓ CAVALO MECANICO LS',
      TOCO: 'TOCO',
      TOCO_3_4: 'TOCO 3/4',
      TRITREM: 'TRITREM',
      TRUCK: 'TRUCK',
      UTILITARIO: 'UTILITÁRIO',
      VAN: 'VAN',
      VUC_HR: 'VUC / HR',
      OUTROS: 'OUTROS',
    },
    MarcaVeiculo: {
      CHEVROLET: 'CHEVROLET',
      FIAT: 'FIAT',
      FORD: 'FORD',
      HONDA: 'HONDA',
      HYUNDAI: 'HYUNDAI',
      IVECO: 'IVECO',
      MAN: 'MAN',
      MERCEDES: 'ENZ',
      PEUGEOT: 'PEUGEOT',
      RENAULT: 'RENAULT',
      SCANIA: 'SCANIA',
      TOYOTA: 'TOYOTA',
      VOLKSWAGEN: 'VOLKSWAGEN',
      VOLVO: 'VOLVO',
      YAMAHA: 'YAMAHA',
      OUTROS: 'OUTROS',
    },
    TipoCarroceria: {
      ABERTO: 'ABERTO',
      BAU: 'BAÚ',
      FRIGORIFICO: 'FRIGORÍFICO',
      REFRIGERADO: 'REFRIGERADO',
      SIDER: 'SIDER',
      OUTROS: 'OUTROS',
      NA: 'NÃO SE APLICA',
    },
    TipoNotificacaoCarga: {
      TODOS: 'Todos',
      NOTIFICAR: 'Notificar',
      PRIORIZAR: 'Priorizar',
    },
  },

  component: {
    driverPerformance: {
      whereAmI: 'Onde estou?',
      empty: 'Nenhum registro para o filtro selecionado',
      approvedWeb: 'Baixas via portal',
      approvedWebLabel: 'Baixa Portal',
      initializedNFs: 'NFs Iniciadas',
      estimatedTime: 'Tempo previsto',
    },
    FilterToggle: {
      filter: 'Filtrar',
      hide: 'Esconder',
    },
    RenderCargaBarcode: {
      label: 'Exibir código de barras',
      header: 'Código de barras',
      headerRecebidos: 'Código de barras Recebido',
      headerEntregues: 'Código de barras Entregue',
      headerPendentesEntrega: 'Código de barras Pendente Entrega',
    },
    driverPerformanceBar: {
      pending: 'Notas pendentes: {value}',
      success: 'Notas finalizadas com sucesso: {value}',
      ocurrence: 'Notas finalizadas com ocorrência: {value}',
      returned: 'Notas devolvidas: {value}',
    },
    photoSlider: {
      noPhotos: 'Não há fotos',
    },
  },

  view: {
    signIn: {
      title: 'Bem-vindo ao portal iTrack Brasil',
      inputPlaceholder: 'Digite...',
      subtitle:
        'A maneira mais <span class="ff-secondary"> simples e eficiente </span> de você acompanhar suas ' +
        'entregas e coletas em tempo real.',
      account: 'CPF/CNPJ',
      password: 'Senha',
      signin: 'entrar',
      forgotPassword: 'Esqueceu sua senha?',
      captchaError: 'Captcha inválido',
    },
    tracking: {
      title: 'Rastreamento',
      infoWindow: {
        driver: 'Entregador',
        transporter: 'Transportador',
        infoCielo: 'Informação Adicional',
        license: 'Placa do veículo',
        addressee: 'Destinatário',
        shipper: 'Embarcador',
        nroNotaFiscal: 'Nota fiscal',
        dataCheckIn: 'Data do CheckIn',
        distanciaParaDestino: 'Distância para Destino',
        lastUpdate: 'Último Geoposicionamento',
        estimatedTime: 'Tempo Estimado para Destino',
        loading: 'Calculando...',
        dataPrevisao: 'Data de Previsão',
      },
      filter: {
        period: {
          YEARLY: 'Anual',
          MONTHLY: 'Do ano',
          WEEKLY: 'Semanal',
          DAILY: 'Do mês',
          HOURLY: 'Do dia',
          MINUTELY: 'Cada instante',
        },
        uf: {
          ALL: 'Todos',
          ACRE: 'Acre',
          ALAGOAS: 'Alagoas',
          AMAPA: 'Amapá',
          AMAZONAS: 'Amazônas',
          BAHIA: 'Bahia',
          CEARA: 'Ceará',
          DISTRITO_FEDERAL: 'Distrito Federal',
          ESPIRITO_SANTO: 'Espírito Santo',
          GOIAS: 'Goiás',
          MARANHAO: 'Maranhão',
          MATO_GROSSO: 'Mato Grosso',
          MATO_GROSSO_DO_SUL: 'Mato Grosso do Sul',
          MINAS_GERAIS: 'Minas Gerais',
          PARA: 'Pará',
          PARAIBA: 'Paraíba',
          PARANA: 'Paraná',
          PIAUI: 'Piauí',
          RIO_DE_JANEIRO: 'Rio de Janeiro',
          RIO_GRANDE_DO_NORTE: 'Rio Grande do Norte',
          RIO_GRANDE_DO_SUL: 'Rio Grande do Sul',
          RONDONIA: 'Rondônia',
          RORAIMA: 'Roraima',
          SANTA_CATARINA: 'Santa Catarina',
          SAO_PAULO: 'São Paulo',
          SERGIPE: 'Sergipe',
          TOCANTINS: 'Tocantins',
        },
        region: {
          ALL: 'Todos',
          CENTRO_OESTE: 'Centro Oeste',
          NORDESTE: 'Nordeste',
          NORTE: 'Norte',
          SUDESTE: 'Sudeste',
          SUL: 'Sul',
        },
      },
      pickups: 'Coletas',
      deliveries: 'Entregas',
      started: 'Iniciadas',
      groupedVehicles: 'Veículos agrupados',
      inTransit: 'Veículos em trânsito',
      inTransitOnTime: 'Veículos em trânsito dentro do prazo',
      inTransitDelayed: 'Veículos em trânsito fora do prazo',
      integrationVehicle: 'Veiculo de integração',
      checkin: {
        checkin: 'Entrega com Checkin',
        trajeto: 'Entrega em Trajeto',
        custom: 'Rastreio personalizado',
      },
    },
    resetPassword: {
      title: 'Esqueceu sua senha?',
      subtitle:
        'Informe seu e-mail e enviaremos instruções de como alterar sua senha',
      account: 'E-Mail',
      document: 'CNPJ',
      submit: 'Enviar',
      signIn: 'Fazer login',
    },

    recoverPassword: {
      title: 'Recuperar senha',
      newPassword: 'Nova senha',
      confirmPassword: 'Confirmar senha',
      submit: 'Enviar',
    },

    cockpit: {
      title: 'Cockpit',
      chartLineTip: 'Gráfico linha',
      chartBarTip: 'Gráfico barra',
      performanceDataTip: 'Performance hoje',
      performanceOrigemTip: 'Performance por Origem',
      performanceEmbarcadorTip: 'Performance por Transportador',
      performance: 'Performance',
      driverPerformanceTip: 'Performance dos Motoristas',
      bi: 'BI',
    },

    deliveryList: {
      title: 'Comprovantes e listas',
      subtitle: 'Consulta por Documento',
      clickToCopy: 'CLIQUE PARA COPIAR',
      queryByDocument: 'Consulta por Nota Fiscal',
      importCsv: 'Importar CSV',
      exportCsv: 'Exportar CSV',
      exportXlsx: 'Exportar XLSX',
      cadastrarCsv: 'Cadastrar Entregador via CSV',
      exportComplete: 'Versão completa',
      exportSimplified: 'Versão simplificada',
      queryNf: 'Consulta Múltipla (CSV)',
      queryNfAlt: 'Consulta de Múltiplas N.Fs por CSV',
      downloadTemplate: 'baixar template',
      tipImportCsv:
        'Opção utilizada para importar no Portal iTrack as informações preenchidas no template.',
      tipExportCsv:
        'Opção utilizada para baixar o arquivo com os CPFs/CNPJs e respectivos e-mails ' +
        'que já se encontram cadastrados no Portal iTrack.',
      tipTemplate:
        'Funcionalidade opcional a ser utilizada quando os destinatários para recebimento ' +
        'de notificações de início e finalização das entregas inexistirem ' +
        'ou forem diferentes dos já cadastrados na SEFAZ.' +
        '<br>' +
        'Para os casos que houver a necessidade de envio de mais de um e-mail de notificação para ' +
        'um mesmo destinatário o usuário deverá, obrigatoriamente, repetir ' +
        'o CPF/CNPJ nas linhas subsequentes e inserir os respectivos e-mails desejados.',
      dateFilterCantBeEmpty: 'Data de início e fim não pode ser vazio',
      startFilterCantBeEmpty: 'Data de início criação da carga não pode ser vazio',
      endFilterCantBeEmpty: 'Data de fim criação da carga não pode ser vazio',
      dataEntregaInicioCantBeEmpty: 'Data de inicio entrega não pode ser vazio',
      dataEntregaFimCantBeEmpty: 'Data de fim entrega não pode ser vazio',
      dataPrevisaoInicioCantBeEmpty: 'Data de inicio previsão de entrega não pode ser vazio',
      dataPrevisaoFimCantBeEmpty: 'Data de fim previsão de entrega não pode ser vazio',
    },

    relatorioGeracaoList: {
      title: 'Relatórios Gerados',
    },

    reportIRoute: {
      title: 'IRoute',
      exportCsv: 'Exportar CSV',
      exportXlsx: 'Exportar XLSX',
    },

    get: {
      deliveryGet: {
        title: 'Detalhe da entrega',
        print: 'Imprimir',
        share: 'Compartilhar',
        addressee: 'Destinatário',
        lacre: 'Lacre',
        shipper: 'Origem',
        receiver: 'Recebedor',
        delivery: 'Dados do recebimento',
        transporter: 'Transportador',
        concreto: 'Concreto',
        infoCielo: 'Informação Adicional',
        driver: 'Entregador - Local da entrega',
        receiptPhotos: 'Fotos comprovante',
        occurrencePhotos: 'Fotos ocorrência',
        component: 'Componente - Kit Completo',
        componentInfo:
          'Declaro para os devidos fins a execução dos serviços constantes desse documento',
        audit: 'Auditoria',
        setReason: 'Indique um motivo',
        auditedBy: 'Auditado por:',
        addObservation: 'Adicionar observação',
        inputObservation: 'Escreva uma observação',
        history: 'Histórico',
        noHistory: 'Nenhum histórico',
        recent: 'Recentes',
        older: 'Antigos',
        mapDelivery: 'Entrega',
        mapCheckIn: 'Check-In',
        photoReceipt: 'Fotos Comprovante',
        photoOccurrence: 'Fotos Ocorrência',
        photoProcess: 'Fotos Processo',
        photoInitial: 'Fotos da Coleta',
        uploadProcessoImage: 'Alterar Imagens de Processo',
        photoEpiAndTools: 'Fotos EPIS e Ferramentas',
        photoLacres: 'Fotos lacres e caminhão deslonado',
        photoEspelho: 'Fotos do(s) espelho(s)',
        photoGuias: 'Fotos das guias',
        photoPedrasContrapeso: 'Fotos das pedras do contrapeso',
        photoVolumesArmazenados: 'Fotos volumes armazenados',
        selectAudit: 'Selecione sua posição',
        updateAudit: 'Atualizar auditoria',
        submitAudit: 'Submeter Auditoria',
        emailAuditoria: 'Grupo Responsável',
        uploadComprovanteImage: 'Alterar imagens de comprovante',
        uploadOcorrenciaImage: 'Alterar imagens de ocorrência',
        uploadEpisImage: 'Alterar imagens de EPIS e Ferramentas',
        uploadLacresImage: 'Alterar imagens de lacres e caminhão deslonado',
        uploadEspelhoImage: 'Alterar imagens dos espelhos',
        uploadGuiasImage: 'Alterar imagens das guias',
        uploadPedrasImage: 'Alterar imagens das pedras do contrapeso',
        uploadVolumesImage: 'Alterar imagens dos volumes armazenados',
        uploadInitialImage: 'Alterar imagens da coleta',
        uploadProcessImage: 'Alterar imagens de processo',
        emailNivel: 'Nível do E-mail',
        slaError: 'Não foi possível fazer o cálculo do SLA, endereço não encontrado na tabela',
        occurrenceDescription: 'Descrição da Ocorrência: {value}',
      },
      deliveryGetCielo: {
        title: 'Ordem de Serviço',
        items: 'Mercadoria Transportada',
        qtde: 'Qtde.',
        installedProducts: 'Produtos Instalados',
        assetNumber: 'Nº do ativo',
        collectedProducts: 'Produtos Coletados',
      },
      deliveryGetCteListView: {
        title: 'Notas CTE',
        count: 'documentos encontrados',
        select: '> SELECIONE O <img src="./img/itrack/view-circle-contrast.svg" alt="view-circle"> ' +
            'PARA EXIBIR OS DETALHES DAS SUAS ENTREGAS',
      },
      deliveryGetNotasEmAtrasoListView: {
        title: 'Notas em atraso',
        count: 'notas encontradas',
        select: '> SELECIONE O <img src="./img/itrack/view-circle-contrast.svg" alt="view-circle"> ' +
            'PARA EXIBIR OS DETALHES DAS SUAS ENTREGAS',
        exportCsv: 'Exportar CSV',
        exportXlsx: 'Exportar XLSX',
      },
      deliverySacAttemptResponse: {
          title: 'SAC Público CNPJ/CPF',
          exportXlsx: 'Exportar XLSX',
          exportCsv: 'Exportar CSV',
      },
    },

    persist: {
      deliveryPersist: {
        titleDefault: 'Cadastro de entrega',
        titleComDanfe: 'Cadastro de entrega com DANFE',
        titleSemDanfe: 'Cadastro de entrega sem DANFE',
        titleEdit: 'Editar entrega',
        selectDriver: 'Selecione o entregador',
        RECEIVER_ADDRESS:
          'Usar o endereço do destinatário como endereço de entrega',
        ANOTHER_ADDRESS: 'Usar outro endereço de entrega',
        noOptions: 'Lista vazia',
        searchLabel: 'Nome/Razão Social',
        noResults: 'Nenhum destinatário encontrado',
      },
      userPersist: {
        title: 'Associar CNPJ ao cadastro',
        createPassword: 'Criar senha',
        repeatPassword: 'Repita a senha',
      },
      driverPersist: {
        title: 'Cadastrar Entregador',
        vehicle: 'Veículo',
        documentation: 'Documentação',
        jorney: 'Jornada',
        responsaveisDoMotorista: 'Responsáveis do Motorista',
        errorJorneyEmpty:
          'Selecionar ao menos um dia da semana para a jornada!',
      },
      driverConnect: {
        title: 'Associar Entregador',
      },
      occurrenceTypePersist: {
        title: 'Cadastrar tipo ocorrência',
        devolvida: 'Insucesso',
        devolvidaDescription:
          'Ao selecionar essa opção, o entregador visualizará no aplicativo estas Descrições ' +
          'de Ocorrência apenas nas cargas selecionadas como Devolução.',
        description:
          'Ao selecionar essa opção, o entregador visualizará no aplicativo estas Descrições ' +
          'de Ocorrência apenas nas cargas selecionadas como Sucesso.',
        ocorrencia: 'Ocorrência',
        ocorrenciaDescription:
          'Ao selecionar essa opção, o entregador visualizará no aplicativo estas ' +
          'Descrições de Ocorrência apenas nas cargas que serão finalizadas com Com Ocorrência.',
        addMore: 'Adicionar mais',
      },
      holidayPersist: {
        title: 'Cadastrar Feriado',
        cancel: 'Cancelar',
      },

      personTypePersist: {
        title: 'Cadastrar Tipo de recebedor',
        addMore: 'Adicionar mais',
      },
      alertPersist: {
        title: 'Cadastrar Alerta',
      },
      occurrenceTypeSucessPersist: {
        title: 'Cadastrar tipo de finalização com sucesso',
        description:
          'Ao selecionar essa opção, o entregador visualizará no aplicativo estas Descrições ' +
          'de Finalização apenas nas cargas selecionadas como Sucesso.',
        addMore: 'Adicionar mais',
      },
      CheckListEntregaPersist: {
        title: 'Cadastrar Checklist',
        description:
          'Ao selecionar essa opção, o entregador visualizará no aplicativo estas Descrições ' +
          'de Finalização apenas nas cargas selecionadas como Sucesso.',
        addMore: 'Adicionar mais',
        tipoCheckListEntrega: 'Tipo CheckList',
      },
      CnpjBulklogPersist: {
        title: 'CNPJ não integrado WebApi',
        addMore: 'Adicionar mais',
        tipoFuncao: 'Tipo de Função',
        nome: 'Razão Social',
        cnpj: 'Cnpj',
        ativo: 'Ativo',
      },
      auditReasonPersist: {
        title: 'Cadastrar motivo para auditoria',
      },
      hideResponsavelNotasPersist: {
        title: 'Cadastrar Transportador',
        razaoSocial: 'Razão Social',
        cnpj: 'CNPJ',
        ativo: 'Ativo',
        addMore: 'Adicionar mais',
      },
      auditEmailPersist: {
        title: 'Cadastrar E-mail Auditoria',
        email: 'E-mails',
        ativo: 'Ativo',
        addMore: 'Adicionar mais',
        emailTier: 'Nível do Email',
      },
      riskAreaPersist: {
        title: 'Cadastrar Área de Risco',
        addMore: 'Adicionar mais',
      },
    },

    manage: {
      deliveryDriver: {
        title: 'Associar Entregas/Cargas ao Entregador',
        associateDriver: 'Associar entregador',
        selectAll: 'Selecionar todas as cargas desta página',
        queryDriverAssociation: 'Associar entregador via CSV',
      },
      cnpjBulk: {
        title: 'CNPJ não integrado WebApi',
      },
      personTypeList: {
        title: 'Lista Tipo de recebedor',
      },
      deliveryRegister: {
        title: 'Cadastro de Entregas/Coletas',
        subtitle1: 'Cadastro de Informações',
        subtitle2: 'Cadastro em Lote',
        withDanfe: 'Com Danfe',
        withoutDanfe: 'Sem Danfe',
        expectedDate: 'Data Prevista',
        orderNumber: 'NR° PEDIDO',
        issueDate: 'Data Emissão',
        withNotfis: 'Com Notfis',
        withCTE: 'Com CTE',
        withCTEReadNf: 'Com CTE / NFs',
      },
      deliveryEnd: {
        title: 'Baixas Entregas/Coletas',
        endSelected: 'Finalizar entregas selecionadas',
        excludeSelected: 'Excluir entregas selecionadas',
        selectAll: 'Selecionar todas as cargas desta página',
        endDelivery: 'Finalizar entrega',
        excludeDelivery: 'Excluir entrega',
      },
      userList: {
        title: 'Associar CNPJ ao cadastro',
        maxResponsavel: 'Total Permitido',
        count: 'Cadastros em Vigor',
        remaining: 'Cadastros Restantes',
        addAssociate: 'Adicionar Associado',
      },
      companyList: {
        title: 'Associados',
      },
      driverList: {
        title: 'Entregadores',
        add: '+ Adicionar',
        connect: 'Associar',
        selectToNotify: 'Selecione para Notificar',
        notifyAll: 'Notificar Todos',
        message: 'Mensagem',
        search: 'Buscar',
        noDriverSelected: 'Você não selecionou nenhum motorista',
        successOnNotify: 'Motoristas notificados com sucesso!',
        removeDriver: 'Desconectar-se ao motorista',
        areYouSureToRemoveDriver:
          'Tem certeza que deseja se desconectar deste motorista?',
      },
      driverTranshipmentList: {
        title: 'Transbordo',
        editTranshipment: 'Editar transbordo',
      },
      occurrenceTypeList: {
        title: 'Tipo Ocorrência',
      },
      alertList: {
        title: 'Tipo de Alerta',
      },
      occurrenceSucessTypeList: {
        title: 'Tipo de finalização com sucesso',
      },
      checkListEntrega: {
        title: 'CheckList Entrega',
      },
      secondaryUserList: {
        title: 'Cadastro de Usuários',
        add: 'Adicionar',
        removeUser: 'Desconectar-se ao usuário',
        areYouSureToRemoveUser:
          'Tem certeza que deseja se desconectar deste usuário?',
      },
      auditReasonList: {
        title: 'Motivos para auditoria',
      },
      settings: {
        title: 'Configurações',
        checkbox: {
          enableNotificationsCarga: 'Permitir Notificações de Carga',
          enableNotificationsTrajeto: 'Permitir Notificações de Trajeto',
          enableDataPrevisao: 'Permitir Data de Previsão de Entrega',
          enableBotaoNaoEntregarCarga:
              'Permitir Botão Não Entregarei Mais a Carga',
          disableDataEntregaInferiorDataEmissao: 'Não Permitir Data Entrega Inferior a Data de Emissão',
          disableDataEntregaInferiorDataCriacao: 'Não Permitir Data Entrega Inferior a Data de Criação',
          disableFinalizacaoMultiplasApp: 'Não Permitir Finalização em Lote via Aplicativo' ,
        },
        changeRaioAuditoria: {
          title: 'Alterar Raio Auditoria',
          raioAuditoriaCheckinMetros: 'Raio Auditoria Checkin em Metros',
          raioAuditoriaEntregaMetros: 'Raio Auditoria Entrega em Metros',
          updateRaioAuditoria: 'Salvar Raio Auditoria',
        },
        registerDestinatario: {
          title: 'Cadastrar destinatário',
          exportXlsx: 'Exportar XLSX',
          importXlsx: 'Importar XLSX',
          downloadTemplate: 'baixar template',
          totalRegistered: '1 cadastro no total | {value} cadastros no total',
          reportTitle: 'Cadastro Destinatário',
        },
        changePassword: {
          title: 'Alterar senha',
          alter: 'Alterar',
          old: 'Antiga',
          new: 'Nova',
          typeAgain: 'Digite novamente',
          mainPassword: {
            title: 'Senha principal',
            description: 'Permite acesso total à conta',
          },
          visualizadorPassword: {
            title: 'Senha de Visualizador',
            description: 'Permite acessar à conta no modo \'somente leitura\'',
          },
          SACPassword: {
            title: 'Senha SAC',
            description: 'Permite acessar à conta no modo SAC',
          },
        },
        satisfactionSurvey: {
          title: 'Pesquisa de Satisfação',
          firstQuestion: 'Primeira pergunta',
          secondQuestion: 'Segunda pergunta',
          silentPhoto: 'Usar foto silenciosa',
          customQuestion: 'Pergunta personalizada',
        },
        updateSelectedPasswords: 'Alterar Senhas Selecionadas',
        updateSatisfactionSurvey: 'Alterar Pesquisa de Satisfação',
      },
      smsNotificationSettings: {
        title: 'Configurações de SMS',
        addSms: 'Adicionar SMS',
      },
      whatsappNotificationSettings: {
        title: 'Configurações de Mensagem WhatsApp',
        add: 'Adicionar Mensagem',
      },
      emailNotificationSettings: {
        title: 'Configurações de E-mail',
        addEmail: 'Adicionar E-mail',
        textConfigEnvio: 'Disparo ao iniciar :',
        radioNotaFiscal: 'Nota Fiscal',
        radioCTE: 'CTE',
        emailHeaderImage: 'Imagem do Cabeçalho do E-Mail',
        emailFooterImage: 'Imagem do Rodapé do E-Mail',
        editImage: 'Enviar Imagem',
        removeImage: 'Remover Imagem',
        bestSize200x200:
          'Utilize uma imagem com o tamanho de 200x200 pixels para uma melhor exibição',
        bestSize500x130:
          'Utilize uma imagem com o tamanho de 500x130 pixels para uma melhor exibição',
      },
      rotaSla: {
        title: 'Tabela SLA',
        originDestination: 'Origem/Destino',
        emptyTable: 'Sua tabela SLA está vazia',
        info:
          'Baixe o template do modelo CSV, edite o arquivo e envie-o no IMPORTAR CSV',
        setWorkingDays: 'Configurar Dias Úteis',
        segADom: 'Segunda a Domingo',
        segASab: 'Segunda a Sábado',
        segASex: 'Segunda a Sexta',
        emptyNewTable: 'Sua tabela SLA está vazia. ' +
            'Baixe o template do modelo CSV, edite o arquivo e envie-o no IMPORTAR CSV',
        errorCalendarizacao: {
          seg: 'Linha {line} - Calendarização Inválida - Coluna SEGUNDA',
          ter: 'Linha {line} - Calendarização Inválida - Coluna TERÇA',
          qua: 'Linha {line} - Calendarização Inválida - Coluna QUARTA',
          qui: 'Linha {line} - Calendarização Inválida - Coluna QUINTA',
          sex: 'Linha {line} - Calendarização Inválida - Coluna SEXTA',
          sab: 'Linha {line} - Calendarização Inválida - Coluna SÁBADO',
          dom: 'Linha {line} - Calendarização Inválida - Coluna DOMINGO',
        },
        importCsv: 'Importar CSV - Tabela SLA',
        setSlaHolidays: 'Cadastrar Feriados',
      },
      holidayList: {
        title: 'Feriados',
        add: '+ Adicionar',
        removeHoliday: 'Remover Feriado',
        areYouSureToRemoveHoliday:
          'Tem certeza que deseja remover esse feriado?',
        backToSlaTable: 'Voltar para tabela SLA',
        alert: 'O feriado cadastrado será considerado para todas as cidades',
      },
      addresseeEmail: {
        title: 'Lista de E-Mails',
        selectAddressee: 'Selecione o destinatário',
        cpfCnpj: 'CPF / CNPJ - Destinatário',
        emails: 'Email - Destinatário',
        noEmails: 'Não há e-mails registrado para este destinatário',
      },
      countersign: {
        title: 'Lista Contra Senha',
        selectCountersign: 'Selecione o destinatário',
        cpfCnpj: 'CPF / CNPJ - Destinatário',
        countersigns: 'Cel - Destinatário',
        noCountersigns: 'Não é possível enviar contra senha para este destinatário',
      },
      hideResponsavelNotas: {
        title: 'Ocultar Notas do Transportador',
        add: '+ Adicionar',
      },
      auditEmail: {
        title: 'E-mail Auditoria',
        add: '+ Adicionar',
        setupAutomaticNotification: 'Configurar notificação automática',
      },
      riskArea: {
        title: 'Listar CEP Área de Risco',
        add: '+ Adicionar',
        exportXlsx: 'Exportar XLSX',
        exportCsv: 'Exportar CSV',
        importCsv: 'Importar CSV',
        downloadTemplate: 'Baixar Template',
        errorNotificar: 'Campo Notificar Inválido',
      },
      alertDelayedNotasEmail: {
        title: 'Configurar e-mail de alerta de nota em atraso',
        selectTransportador: 'Selecione o transportador',
        exportCsv: 'Exportar CSV',
        importCsv: 'Importar CSV',
        cpfCnpj: 'CPF / CNPJ - Transportador',
        emails: 'Email - Transportador',
        noEmails: 'Não há e-mails registrado para este transportador',
        cnpfCnpjCannotBeNull: 'CPF/CNPJ transportador não pode ser vazio',
      },
    },

    reports: {
      deliveryIssue: {
        title: 'Devoluções e Ocorrências',
      },
      deliveryChecklist: {
        title: 'Analítico Checklist',
      },
      deliveryReceiver: {
        title: 'Entregas por Destinatário',
      },
      deliveryShipper: {
        title: 'Entregas por Embarcador/Transportador',
      },
      deliveryDriver: {
        title: 'Entregas por Entregador',
      },
      deliveryMonth: {
        title: 'Entregas por Mês',
      },
      deliveryPeriod: {
        title: 'Entregas por Período',
      },
      deliveryVehicle: {
        title: 'Entregas por Tipo Veículo',
      },
      deliveryUf: {
        title: 'Entregas por UF',
      },
      deliveryCanceled: {
        title: 'Entregas Canceladas',
      },
      deliveryAlertHistory: {
        title: 'Alertas de Trajeto',
      },
      deliverySatisfactionSurveyHistory: {
        title: 'Pesquisa de Satisfação',
      },
      deliveryTracking: {
        title: 'Jornada do Entregador',
      },
      deliveryAudit: {
        title: 'Auditoria por Geoposicionamento',
      },
      deliverySla: {
        title: 'SLA',
      },
      deliveryEnded: {
        title: 'Analíticos de Entregas',
      },
      deliveryMovement: {
        title: 'Movimentação',
      },
      deliverySac: {
        title: 'Tracking (SAC)',
        nfHasFound: 'notas fiscais encontradas',
        selectToView: 'Selecione {0} para exibir os detalhes da nota fiscal',
        updateSearch: 'Atualizar',
        cleanSearch: 'Limpar busca',
        deliveryDetails: 'Comprovante',
        searchBy:
          'Encontre notas-fiscais por DANFE, NF, CTE, CNPJ ou CPF do destinatário',
        addressee: 'Destinatário',
        transporter: 'Transportador',
        shipper: 'Embarcador',
      },
      deliverySacPublic: {
        title: 'Portal de atendimento de pedidos',
        subtitle:
          'Para consultar o status de entregas ou coletas dos seus pedidos ' +
          'selecione o tipo de documento e digite o número.',
        selectDocType: 'Selecione aqui o tipo de documento para a consulta',
        submit: 'Consultar Pedidos',
        nfHasFound: 'documentos encontrados',
        selectToView: 'Selecione {0} para exibir os detalhes das suas entregas',
        updateSearch: 'Atualizar',
        backToList: 'Voltar à lista',
        backToSearch: 'Voltar à busca',
        deliveryDetails: 'Comprovante',
        searchBy: 'Busque seus pedidos através do filtro acima',
        addressee: 'Destinatário',
        transporter: 'Transportador',
        shipper: 'Embarcador',
        inputPassword: 'Por favor insira sua credencial',
        login: 'Cpf/Cnpj',
        password: 'Senha (8 dígitos)',
        fragmentDinamicEmptyList:
          'Consultas disponíveis somente para documentos com emissão a partir de ',
      },
      deliverySacPublicConcreserv: {
        title: 'Bem-vindo ao portal CONCRESERV',
        subtitle: 'Realizando projetos e concretizando sonhos',
      },
      deliverySacPublicCnhIveco: {
        expected: 'No prazo',
        delayed: 'Em atraso',
        finished: 'Finalizada',
      },
      riskArea: {
        title: 'Area de Risco',
      },
      configNovaSla: {
        title: 'Tabela SLA',
      },
      securityChecklist: {
        title: 'Checklist de Segurança',
      },
      deliverySecurityChecklist: {
        title: 'Analítico Checklist de Segurança',
      },
      auditByDelivery: {
        title: 'Auditoria Entrega',
        exportXlsx: 'Exportar XLSX',
        exportCsv: 'Exportar CSV',
      },
      clientNotification: {
        title: 'Notificação do Cliente',
        exportXlsx: 'Exportar XLSX',
        exportCsv: 'Exportar CSV',
      },
    },
  },

  modal: {
    alertCargaOccurrence: {
      title: 'Alerta de ocorrência',
      subtitle: 'Alerta de ocorrência!',
    },
    alertCargaReturned: {
      title: 'Alerta de devolução',
      subtitle: 'Alerta de devolução!',
    },
    alertAlertaCarga: {
      title: 'Alerta de trajeto',
      subtitle: 'Alerta de trajeto!',
    },
    alertMotoristaCancelamentoCarga: {
      title: 'Alerta de cancelamento de carga',
      subtitle: 'Alerta de cancelamento de carga!',
    },
    share: {
      title: 'Compartilhar',
      subtitle: 'Compartilhe o link desta entrega',
      copyLink: 'copiar link',
      facebook: 'Facebook',
      twitter: 'Twitter',
      linkedin: 'LinkedIn',
    },
    deliveryRegister: {
      title: {
        expectedDate: 'Cadastrar data de previsão',
        orderNumber: 'Cadastrar número de pedido',
        issueDate: 'Cadastrar data de emissão',
        multipleWithDanfe: 'Cadastrar em lote com Danfe',
        multipleWithoutDanfe: 'Cadastrar em lote sem Danfe',
        multipleWithNotfis: 'Cadastrar em lote com notfis',
      },
      subtitle: {
        expectedDate:
          'Arraste e solte aqui seu arquivo com a data de previsão de entrega no formato CSV ou XLSX',
        orderNumber:
          'Arraste e solte aqui seu arquivo no formato CSV ou XLSX contendo os números de pedido',
        issueDate:
          'Arraste e solte aqui seu arquivo com a data de emissão no formato CSV ou XLSX',
        multipleWithDanfe:
          'Arraste e solte aqui os seus arquivos XML contendo Danfe',
        multipleWithoutDanfe:
          'Arraste e solte aqui o seu arquivo JSON, XML, XLSX ou CSV contendo entregas sem Danfe',
        multipleWithNotfis: 'Arraste e solte aqui arquivos Notfis',
        multipleWithCTE: 'Arraste e solte aqui arquivos XML com conteúdo CTE',
        multipleWithCTEReadNf:
          'Arraste e solte aqui arquivos XML com conteúdo CTE',
      },
      downloadHere: {
        expectedDate:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sla.xlsx">download aqui</a>' +
          'da planilha modelo',
        expectedDateWithPrevisaoAtualizada:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sla2.xlsx">download aqui</a>' +
          'da planilha modelo',
        multipleWithoutDanfe:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithCorreios:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe_correios.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithEmailNotification:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe2.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithCorreiosWithEmailNotification:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe_correios2.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithSmsNotification:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe3.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithCorreiosWithSmsNotification:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe_correios3.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithEmailAndSmsNotification:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe4.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        multipleWithoutDanfeWithCorreiosWithEmailAndSmsNotification:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_sem_danfe_correios4.xlsx">download aqui</a>' +
          'da planilha modelo para cargas SEM DANFE',
        orderNumber:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_nro_pedido.xlsx">download aqui</a>' +
          'da planilha modelo',
        issueDate:
          'Faça' +
          '<a class="contrast" href="./files/exemplo_de_arquivo_data_emissao.xlsx">download aqui</a>' +
          'da planilha modelo',
      },
      tip1: '- Todos os campos em branco serão ignorados no upload',
      tip2: '- Evite a utilização de acentos para uma melhor formatação',
      selectFile: 'Selecione o arquivo',
    },
    deliveryDriverAssociation: {
      title: 'Associar cargas ao entregador',
      itemsSelected: '{0} carga(s) selecionada(s)',
      selectDriver: 'Selecione o entregador para ser associado',
      disassociateDriver: 'Remover carga do motorista',
    },
    deliveryEnd: {
      title: 'Finalizar Entregas',
      subtitle:
        'Como você gostaria de registrar a entrega das cargas selecionadas?',
      itemsSelected: '{0} carga(s) selecionada(s)',
      noOccurrence: 'Carga sem ocorrência',
      occurrence: 'Carga com ocorrência',
      returned: 'Carga devolvida',
      tipNoOccurrence: 'Para entrega ou coleta',
      tipOccurrence: 'Para entrega ou coleta parcial',
      tipReturned: 'Para entrega ou coleta',
      form: {
        receiver: 'Responsável pelo recebimento',
        own: 'Próprio',
        other: 'Outro',
        undefined: 'Responsável não identificado',
        docType: 'Selecione o tipo de documento',
        cnpj: 'CNPJ',
        cpf: 'CPF',
        rg: 'RG',
        receipts: 'Comprovantes',
        sendReceipts: 'Enviar comprovantes',
        occurrence: 'Ocorrência',
        sendOccurrence: 'Enviar Ocorrência',
        occurrenceType: 'Tipo de ocorrência',
        occurrenceDescription: 'Descreva a ocorrência',
        endSuccess: 'Tipo de Finalização com Sucesso',
      },
    },
    deliveryRemove: {
      title: 'Excluir Entregas',
      subtitle: 'Tem certeza que deseja excluir {0} entrega(s) selecionada(s)?',
    },
    modalConfirmEditCarga: {
      title: 'Editar Carga Inicializada',
      subtitle: 'Insira a senha para editar a carga',
      success: 'Carga alterada para Pendente',
    },
    modalScheduledReport: {
      title: 'Relatório Agendado',
      info: 'RELATÓRIO AGENDADO PARA EXTRAÇÃO AMANHÃ NA TELA DE INDICADORES -> RELATÓRIOS GERADOS',
    },
    modalAuditAutomaticNotification: {
      title: 'Configurar Notificação Automática',
      subtitle: 'Disparar e-mail a cada',
      subtitleDays: 'dia(s)',
    },
    modalNotification: {
      title: 'Notificação',
      notify: 'Notificar',
      prioritize: 'Priorizar',
      description: 'Descrição',
    },
    modalDeliveryRemovePassword: {
      title: 'Excluir entrega finalizada',
      body: 'Insira a senha e uma justificativa para excluir a(s) entrega(s) selecionada(s)',
      password: 'Senha',
      reason: 'Justificativa',
    },
    modalDriverPassword: {
      title: 'Alterar a senha do entregador',
      body: 'Insira uma nova senha de acesso ao aplicativo do entregador {name}',
      warning:
          'Ao logar no Aplicativo o entregador deve definir uma nova senha. ' +
          'Se houver entregas não sincronizadas no Aplicativo do entregador as informações serão perdidas e ' +
          'terão que ser finalizadas novamente',
      password: 'Senha',
      confirmPassword: 'Confirmar Senha',
      error: {
        invalidPasswordLength: 'É obrigatório informar no mínimo 5 caracteres para definir a senha',
        passwordDontMatch: 'As senhas não estão iguais',
        passwordCannotBeEmpty: 'Senha não pode ser vazia',
        confirmPasswordCannotBeEmpty: 'Confirmar senha não pode ser vazia',
      },
    },
    modalAudit: {
      title: 'Auditoria Entrega',
      submit: 'Submeter Auditoria',
      fotosComprovantes: 'Fotos Comprovantes',
      fotosOcorrencia: 'Fotos Ocorrência',
    },
    modalCargaFinalizadaParaNaoIniciada: {
      title: 'Editar carga finalizada',
      body: 'Insira a senha para mudar o status da carga finalizada para pendente',
      send: 'Enviar',
      password: 'Senha',
      passwordCannotBeEmpty: 'Campo senha não pode ser vazio',
      success: 'Carga alterada para pendente',
    },
  },

  persist: {
    number: 'Numérico',
    datetime: 'Data e Hora',
    submit: 'Enviar',
  },

  classes: {
    DeliveryShipperRequest: {
      title: 'Delivery Shipper Request',
      columns: {
        cnpj: 'CPF/CNPJ Embarcador/Transportador',
        transportadora: 'Embarcador/Transp',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
      },
    },
    ReportsIRouteIndicatorResponse: {
      title: 'IRoute',
      columns: {
        nroNotaFiscal: 'NF',
        danfe: 'Danfe',
        nomeTransportador: 'Razão Social(Transportador)',
        enderecoEntrega: 'Endereço de Entrega',
        dataCriacao: 'Criação',
        dataBaixa: 'Baixa',
        dataEntrega: 'Entrega',
        tempoEntrega: 'Tempo',
        prevEntrega: 'Previsão',
        destDocument: 'CPF/CNPJ',
        destNome: 'Razão Social',
        destCep: 'CEP',
        destMunicipio: 'Município',
        destEstado: 'UF',
        destPais: 'País',
        destTelefone: 'Telefone',
        destNumero: 'Nro',
        destLongitude: 'Longitude',
        destLatitude: 'Latitude',
        emitDocument: 'CPF/CNPJ(Emitente)',
        emitNome: 'Razão Social(Emitente)',
        pesoEntrega: 'Peso',
        volumeEntrega: 'Volume',
        valorMonetarioEntrega: 'Valor Monetário',
        duracaoEntrega: 'Duração',
        destinatarioInicioAtendimento: 'Horário Inicio',
        destinatarioFimAtendimento: 'Horário Fim',
        docTransportador: 'CPF/CNPJ(Transportador)',
      },
    },
    CnpjBulkLog: {
      columns: {
        nome: 'Razão Social',
        cnpj: 'Cnpj',
        ativo: 'Ativo',
        idCnpjBulklogPk: 'ID',
        idTipoChecklistEntregaPkAlt: 'Tipo Função',
      },
    },
    ChecklistEntrega: {
      title: 'CheckList Entreda',
      columns: {
        idOcorrenciaExterna: 'Ocorrência Externa',
        descricao: 'Descrição',
        idTipoChecklistEntregaPk: 'Tipo de CheckList',
        ativo: 'Ativo',
        ehEditavel: 'Editável',
        idTipoChecklistEntregaPkAlt: 'Tipo de CheckList',
        idOcorrenciaExternaAlt: 'Código da Ocorrência',
        codigoServico: 'Código do Serviço',
      },
    },
    TipoPessoaRecebedor: {
      title: 'Tipo Pessoa Recebedor',
      columns: {
        idTipoPessoaPk: 'idTipoPessoa',
        nome: 'Tipo Recebedor',
        ativo: 'Ativo',
      },
    },
    JornadaMotorista: {
      title: 'Jornada Motorista',
      columns: {
        horaInicio: 'Início',
        horaFim: 'Fim',
        rangeCepInicial: 'CEP Inicial',
        rangeCepFinal: 'CEP Final',
        segunda: 'Segunda-Feira',
        terca: 'Terça-Feira',
        quarta: 'Quarta-Feira',
        quinta: 'Quinta-Feira',
        sexta: 'Sexta-Feira',
        sabado: 'Sábado',
        domingo: 'Domingo',
        ativo: 'Ativo',
      },
    },
    InfoCargaAdicional: {
      title: 'Informação Adicional',
      columns: {
        horaFunc: 'Hor.  Func.',
        escopoAtendimento: 'Escopo do Atendimento',
        ramoAtividade: 'Ramo de Atividade',
        gestorComercial: 'Gestor Comercial',
        nomeFantasia: 'Nome Fantasia',
        contato: 'Contato',
        observacao: 'Observação',
        segmento: 'Segmento',
        tipoInstalacao: 'Tipo de Instalação',
        ocorrencia: 'Ocorrência',
        ocorrenciaManutencao: 'Ocorrência Manutenção',
        telefoneAdicional: 'Telefone Adicional',
      },
    },
    DeliveryShipperResponse: {
      title: 'Delivery Shipper',
      columns: {
        id: 'ID',
        nome: 'Embarcador/Transp',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
        mes: 'Mês',
        documento: 'CNPJ Embarcador/Transp',
      },
    },
    DeliveryIssuesResponse: {
      title: 'Delivery Shipper',
      columns: {
        actions: '',
        outOf: 'de',
        ordinal: 'ª',
        tempoEntrega: 'Tempo de Entrega',
        days: 'd',
        hours: 'h',
        minutes: 'm',
        id: 'ID',
        carga: 'Carga',
        endereco: 'Endereço',
        motorista: 'ENTREGADOR',
        danfe: 'Danfe',
        tentativas: 'Tentativas de Entrega',
        dataCriacao: 'Data/Hora Criação',
        dataPrevisao: 'Previsão de Entrega',
        status: 'Status',
        tipoOcorrencia: 'Tipo de Ocorrência',
        nroFotosOcorrencia: 'Fotos Ocorrência',
        celularMotorista: 'Telefone do Entregador',
        destinatario: 'Destinatário',
        telDestinatario: 'Telefone do Destinatário',
        nroNotaFiscal: 'NF/Documento',
      },
    },
    DeliveryIssuesRequest: {
      title: 'Delivery Shipper',
      columns: {
        startDate: 'Período inicial',
        endDate: 'Período final',
        motorista: 'Entregador',
        status: 'Status',
        event: 'Ocorrência',
        audit: 'Auditoria',
        docs: 'Consulta por Documento',
        documentResponsavel: 'CPF/CNPJ Embarcador/Transportador',
        documentDestinatario: 'CPF/CNPJ Destinatário',
      },
    },
    Motorista: {
      title: 'Motorista',
      profilePictureUnavailable: 'Imagem indisponível',
      columns: {
        endereco: 'Cidade / UF',
        idMotoristaPk: 'ID',
        nome: 'Nome',
        cpf: 'CPF',
        rg: 'RG',
        celular: 'Celular',
        placaVeiculo: 'Placa do Veículo',
        senha: 'Senha',
        codigoSms: 'Codigo Sms',
        dataNascimento: 'Data de Nascimento',
        email: 'Email',
        telefoneFixo: 'Telefone Fixo',
        phone: 'Telefone',
        tipoVeiculo: 'Tipo Veiculo',
        tipoCarreta: 'Tipo Carreta',
        tipoCarroceria: 'Tipo de Carroceria',
        placaCarroceira: 'Placa Carroceira',
        antt: 'ANTT',
        rntrc: 'Rntrc',
        cnh: 'Cnh',
        urlImagem: '',
        dataCriacao: 'Data Criacao',
        ativo: 'Ativo',
        marcaVeiculo: 'Marca do Veículo',
        idResponsavelCriadorFk: 'Id Responsavel Criador Fk',
        nomeIndicador: 'Nome Indicador',
        tokenAndroid: 'Token Android',
        versao: 'Versão do app',
        transbordoEntrega: 'Pode transbordar',
        transbordoRecebimento: 'Pode receber transbordo',
        dataCadastroEntregador: 'Data do cadastro do entregador',
        idEnderecoFk: 'Id Endereco Fk',
        horaInicio: 'Início Jornada',
        horaFim: 'Fim Jornada',
        rangeCepInicial: 'CEP Inicial',
        rangeCepFinal: 'CEP Final',
        marcaAparelho: 'Marca do Aparelho',
        modeloAparelho: 'Modelo do Aparelho',
      },
    },
    MotoristaTransbordo: {
      title: 'Transbordo',
      columns: {
        podeEntregar: 'Pode transbordar',
        podeReceber: 'Pode receber transbordo',
      },
    },
    AlertaCarga: {
      title: 'Alerta Carga',
      columns: {
        alerta: 'Alerta',
        carga: 'Carga',
        cargaDestinatario: 'Destinatário',
        cargaNroNotaFiscal: 'Nota fiscal',
        motorista: 'Entregador',
        idAlertaCargaPk: 'Id Alerta Carga Pk',
        dataAlerta: 'Data Alerta',
        idMotoristaFk: 'Id Motorista Fk',
        idCargaFk: 'Id Carga Fk',
        idAlertaFk: 'Id Alerta Fk',
      },
    },
    Promocao: {
      title: 'Promocao',
      columns: {
        idPromocaoPk: 'Id Promocao Pk',
        nome: 'Nome',
        dataInicio: 'Data Inicio',
        dataFim: 'Data Fim',
        urlImagem: 'Url Imagem',
        urlRedirect: 'Url Redirect',
        dataCriacao: 'Data Criacao',
        ativo: 'Ativo',
      },
    },
    ResponsavelWebhook: {
      title: 'Responsavel Webhook',
      columns: {
        responsavel: 'Responsavel',
        typeWebhook: 'Type Webhook',
        idWebhookPk: 'Id Webhook Pk',
        url: 'Url',
        idResponsavelFk: 'Id Responsavel Fk',
        idTypeFk: 'Id Type Fk',
      },
    },
    AdminConfig: {
      title: 'Admin Config',
      columns: {
        idConfigPk: 'Id Config Pk',
        autorizarMesmoVencido: 'Autorizar Mesmo Vencido',
        indiqueUmAmigo: 'Indique Um Amigo',
        boasVindas: 'Boas Vindas',
        senhaApp: 'Senha App',
        senhaPainel: 'Senha Painel',
      },
    },
    ConfigAlerta: {
      title: 'Config Alerta',
      columns: {
        responsavel: 'Responsavel',
        idConfigAlertaPk: 'Id Config Alerta Pk',
        ativo: 'Ativo',
        idResponsavelFk: 'Id Responsavel Fk',
      },
    },
    CargaMedlog: {
      title: 'Carga Medlog',
      columns: {
        carga: 'Carga',
        idCargaMedlogPk: 'Id Carga Medlog Pk',
        erro: 'Erro',
        idCargaFk: 'Id Carga Fk',
      },
    },
    TipoWebhook: {
      title: 'Type Webhook',
      columns: {
        idTypePk: 'Id Type Pk',
        nome: 'Nome',
        ativo: 'Ativo',
      },
    },
    MotoristaCancelamentoCarga: {
      title: 'Motorista Cancelamento Carga',
      columns: {
        carga: 'Carga',
        cargaNroNotaFiscal: 'Nota fiscal',
        motorista: 'Entregador',
        idCancelamentoPk: 'Id Cancelamento Pk',
        data: 'Data',
        idMotoristaFk: 'Id Motorista Fk',
        idCargaFk: 'Id Carga Fk',
      },
    },
    Auditoria: {
      title: 'Auditoria',
      columns: {
        approved: 'Conforme',
        decline: 'Não Conforme',
        motivo: 'Motivo:',
        auditoriaMotivo: 'Selecione um motivo',
        carga: 'Carga',
        responsavel: 'Auditado por:',
        idAuditoriaPk: 'Id Auditoria Pk',
        conforme: 'Auditado como:',
        dataCanhoto: 'Data da assinatura do canhoto',
        dataCriacao: 'Auditado em:',
        idResponsavelFk: 'Id Responsavel Fk',
        idCargaFk: 'Id Carga Fk',
        idMotivoFk: 'Id Motivo Fk',
      },
    },
    StatusCarga: {
      title: 'Status Carga',
      columns: {
        idStatusPk: 'Id Status Pk',
        nome: 'Nome',
        ativo: 'Ativo',
      },
    },
    ResponsavelVisualizador: {
      title: 'Responsavel Visualizador',
      columns: {
        responsavel: 'Responsavel',
        idVisualizadorPk: 'Id Visualizador Pk',
        nome: 'Nome',
        email: 'Email',
        senha: 'Senha',
        dataCriacao: 'Data Criacao',
        ativo: 'Ativo',
        idResponsavelFk: 'Id Responsavel Fk',
      },
    },
    EsconderMotorista: {
      title: 'Esconder Motorista',
      columns: {
        responsavel: 'Responsavel',
        idEsconderMotoristaPk: 'Id Esconder Motorista Pk',
        data: 'Data',
        idResponsavelFk: 'Id Responsavel Fk',
      },
    },
    CargaSaraiva: {
      title: 'Carga Saraiva',
      columns: {
        idCargaPk: 'Id Carga Pk',
        danfe: 'Danfe',
        notaFiscal: 'Nota Fiscal',
        nomeDestinatario: 'Nome Destinatario',
        documentoDestinatario: 'Documento Destinatario',
        enderecoDestinatario: 'Endereco Destinatario',
        nomeTransportador: 'Nome Transportador',
        dataCriacao: 'Data Criacao',
        ativo: 'Ativo',
      },
    },
    CompartilhamentoApp: {
      title: 'Compartilhamento App',
      columns: {
        motorista: 'Motorista',
        idCompartilhamentoAppPk: 'Id Compartilhamento App Pk',
        qtdCompartilhamento: 'Qtd Compartilhamento',
        idMotoristaFk: 'Id Motorista Fk',
      },
    },
    Administrador: {
      title: 'Administrador',
      columns: {
        idAdministradorPk: 'Id Administrador Pk',
        nome: 'Nome',
        email: 'Email',
        senha: 'Senha',
        dataCriacao: 'Data Criacao',
      },
    },
    Responsavel: {
      title: 'Responsavel',
      columns: {
        actions: '',
        endereco: 'Endereço',
        responsavelFilial: 'Responsavel Filial',
        responsavelResponsavel: 'Responsavel Responsavel',
        idResponsavelPk: 'ID',
        cnpj: 'Cnpj',
        urlLogoEmpresa: 'Url Logo Empresa',
        razaoSocial: 'Razão Social',
        nomeFantasia: 'Nome Fantasia',
        nomeContato: 'Contato',
        telefone: 'Telefone',
        email: 'Email',
        dataVencimento: 'Data Vencimento',
        jaRedefiniuSenha: 'Ja Redefiniu Senha',
        dataCriacao: 'Data Criacao',
        criadoPeloAdmin: 'Criado Pelo Admin',
        ativo: 'Ativo',
        senha: 'Senha',
        senhaVisualizador: 'Senha Visualizador',
        senhaAdmin: 'Senha Admin',
        senhaSac: 'Senha Sac',
        idResponsavelFiltroFilialFk: 'Id Responsavel Filtro Filial Fk',
        permitirAssociado: 'Permitir Associado',
        permitirSerialNumber: 'Permitir Serial Number',
        receberNotificacoesCarga: 'Receber Notificacoes Carga',
        receberNotificacoesTrajeto: 'Receber Notificacoes Trajeto',
        servoIndependente: 'Servo Independente',
        maxResponsaveis: 'Max Responsaveis',
        auditoriaCepCheckInEmMetros: 'Auditoria Cep Check In Em Metros',
        auditoriaCepEntregaEmMetros: 'Auditoria Cep Entrega Em Metros',
        urlImgCabecalho: 'Url Img Cabecalho',
        urlImgRodape: 'Url Img Rodape',
        nomeSaraivaFtp: 'Nome Saraiva Ftp',
        limitarConsulta: 'Limitar Consulta',
        versaoLight: 'Versao Light',
        idEnderecoFk: 'Id Endereco Fk',
        idFilialFk: 'Id Filial Fk',
        apenasVisualizacao: 'Usuário apenas visualização',
        ehFilial: 'Usuário pertence à filial',
      },
    },
    Alerta: {
      title: 'Alerta',
      columns: {
        idAlertaPk: 'Id Alerta Pk',
        descricao: 'Descrição',
        ativo: 'Ativo',
      },
    },
    ResponsavelAssociado: {
      title: 'Responsavel Associado',
      columns: {
        responsavel: 'Responsavel',
        idAssociadoPk: 'Id Associado Pk',
        razaoSocial: 'Razão Social',
        nomeFantasia: 'Nome Fantasia',
        cnpj: 'Cnpj',
        senha: 'Senha',
        ativo: 'Ativo',
        idResponsavelFk: 'Id Responsavel Fk',
      },
    },
    MotoristaResponsavel: {
      title: 'Motorista Responsavel',
      columns: {
        motorista: 'Motorista',
        responsavel: 'Responsavel',
        apelido: 'Apelido',
        idResponsavelFk: 'Id Responsavel Fk',
        idMotoristaFk: 'Id Motorista Fk',
      },
    },
    RequestSsw: {
      title: 'Request Ssw',
      columns: {
        idRequestPk: 'Id Request Pk',
        notaFiscal: 'Nota Fiscal',
        json: 'Json',
      },
    },
    ResponsavelConfigSms: {
      title: 'Responsavel Config Sms',
      columns: {
        responsavel: 'Responsavel',
        statusSms: 'Status Sms',
        idConfigSmsPk: 'Id Config Sms Pk',
        mensagem: 'Mensagem',
        ativo: 'Ativo',
        idResponsavelFk: 'Id Responsavel Fk',
        idStatusFk: 'Id Status Fk',
        ocorrencia: 'Ocorrência',
      },
    },
    ResponsavelConfigEmail: {
      title: 'Responsavel Config Email',
      columns: {
        responsavel: 'Responsavel',
        statusEmail: 'Status Email',
        idConfigEmailPk: 'Id Config Email Pk',
        mensagem: 'Mensagem',
        ativo: 'Ativo',
        sendOnStartOfCteOrNF: 'Disparar e-mail ao inicia NF ou CTE',
        idResponsavelFk: 'Id Responsavel Fk',
        idStatusFk: 'Id Status Fk',
        ocorrencia: 'Ocorrência',
      },
    },
    ResponsavelConfigWhatsapp: {
      title: 'Responsavel Config Whatsapp',
      columns: {
        responsavel: 'Responsavel',
        status: 'Status',
        whatsappApprovalStatus: 'Status de Aprovação',
        idConfigWhatsappPk: 'Id Config Whatsapp Pk',
        mensagem: 'Mensagem',
        ativo: 'Ativo',
        idResponsavelFk: 'Id Responsavel Fk',
        idStatusFk: 'Id Status Fk',
        ocorrencia: 'Ocorrência',
      },
    },
    TipoSms: {
      title: 'Type Sms',
      columns: {
        idTypePk: 'Id Type Pk',
        nome: 'Nome',
        ativo: 'Ativo',
      },
    },
    AuditoriaMotivo: {
      title: 'Auditoria Motivo',
      columns: {
        idMotivoPk: 'Id Motivo Pk',
        nome: 'Nome',
        ativo: 'Ativo',
      },
    },
    PosicaoMotorista: {
      title: 'Posicao Motorista',
      columns: {
        carga: 'Carga',
        motorista: 'Entregador',
        transportador: 'Transportador',
        statusCarga: 'Status',
        danfe: 'Danfe',
        embarcador: 'Embarcador',
        destinatario: 'Destinatario',
        nroNotaFiscal: 'Nota fiscal',
        endereco: 'Endereço',
        idPosicaoPk: 'Id Posicao Pk',
        latitude: 'Latitude',
        longitude: 'Longitude',
        data: 'Data inicialização',
        idMotoristaFk: 'Id Motorista Fk',
        idCargaFk: 'Id Carga Fk',
        centroDeCusto: 'Centro de Custo',
        geoposicionamento: 'Último Geoposicionamento',
        placaVeiculo: 'Placa do Veículo',
        placaVeiculoPopOverAltMessage: 'Placa do cadastro do motorista',
      },
    },
    TokenPush: {
      title: 'Token Push',
      columns: {
        motorista: 'Motorista',
        idTokenPushPk: 'Id Token Push Pk',
        token: 'Token',
        modeloAparelho: 'Modelo Aparelho',
        marcaAparelho: 'Marca Aparelho',
        idMotoristaFk: 'Id Motorista Fk',
      },
    },
    CargaFoto: {
      title: 'Carga Foto',
      columns: {
        carga: 'Carga',
        idFotoPk: 'Id Foto Pk',
        urlImagem: 'Url Imagem',
        ehOcorrencia: 'Eh Ocorrencia',
        idCargaFk: 'Id Carga Fk',
      },
    },
    ClientNotification: {
      columns: {
        startDate: 'Data de início (criação de carga)',
        endDate: 'Data de fim (criação de carga)',
        noticacao: 'Notificação',
        docDestinatario: 'CPF/CNPJ Destinatário',
        docResponsavel: 'CPF/CNPJ Transportador/Embarcador',
        docNF: 'Consulta por nota fiscal',
        docCTE: 'Consulta por CTE',
        consultaCTEPlaceholder:
              'Use vírgula para mais de um CTE. Ex: 1234, 3321, 1234',
        manifesto: 'Manifesto',
      },
    },
    AuditoriaObservacao: {
      title: 'Auditoria Observacao',
      columns: {
        carga: 'Carga',
        responsavel: 'Responsavel',
        idObservacaoPk: 'Id Observacao Pk',
        texto: 'Escreva uma observação',
        replicarCTE: 'Replicar auditoria para cargas com mesmo CTE',
        dataEnvio: 'Data Envio',
        idResponsavelFk: 'Id Responsavel Fk',
        idCargaFk: 'Id Carga Fk',
      },
    },
    TipoOcorrencia: {
      title: 'Tipo Ocorrencia',
      columns: {
        idOcorrenciaPk: 'Id Ocorrencia Pk',
        idOcorrenciaExterna: 'Código da Ocorrência',
        idOcorrenciaExternaAlt: 'Código da Ocorrência (campo obrigatório)',
        nome: 'Descrição da Ocorrência',
        nomeAlt: 'Descrição da Ocorrência (campo obrigatório)',
        ativo: 'Ativo',
        ehDevolvida: 'Devolvida',
      },
    },
    TipoOcorrenciaSucesso: {
      title: 'Tipo de finalização com sucesso',
      columns: {
        idOcorrenciaPk: 'Id Ocorrencia Pk',
        idOcorrenciaExterna: 'Código da Finalização',
        idOcorrenciaExternaAlt: 'Código da Finalização (campo obrigatório)',
        nome: 'Descrição da Finalização',
        nomeAlt: 'Descrição da Finalização (campo obrigatório)',
        ativo: 'Ativo',
      },
    },
    SlaHolidays: {
      columns: {
        date: 'Data',
        desc: 'Descrição',
        day: 'Dia',
        month: 'Mês',
        descricao: 'Descrição',
      },
    },
    CargaCielo: {
      title: 'Carga Cielo',
      columns: {
        codeServiceType: 'Tipo de serviço',
        dataInicioEntrega: 'Data/hora inicial Prazo',
        dataFinalizacao: 'Data/hora entrega',
        dataPrevisao: 'Data/hora fim Prazo',
        status: 'Status',
        tipoDeRemessa: 'Tipo de remessa',
        tipoOcorrenciaSucesso: 'Motivo de Finalização',
        merchantID: 'Maquineta',
        logicalNumber: 'Número Lógico',
        referenceCode: 'Referência',
        businessName: 'Razão Social',
        legalEntityName: 'Nome Fantasia',
        address: 'Endereço',
        neighborhood: 'Bairro',
        city: 'Cidade',
        state: 'Estado',
        addressCode: 'CEP',
        nomeRecebedor: 'Nome do Recebedor',
        documentoRecebedor: 'CPF',
        rgRecebedor: 'RG',
      },
    },
    Carga: {
      title: 'Carga',
      sla: {
        notInformed: 'Não informado',
        slaIn: 'Dentro do SLA',
        slaOut: 'Fora do SLA',
        expected: 'No Prazo',
        delayed: 'Em Atraso',
      },
      columns: {
        riskArea: '',
        riskAreaTip: 'Área de Risco',
        actions: '',
        actionsTrash: '',
        sistema1: 'Sistema 1',
        sistema2: 'Sistema 2',
        responsavel: 'Responsável',
        outroResponsavel: 'Outro Responsável',
        embarcador: 'Embarcador',
        embarcadorRazaoSocial: 'Emitente - Razão Social',
        embarcadorNomeFantasia: 'Emitente - Nome Fantasia',
        embarcadorCpfCnpj: 'Emitente - CPF/CNPJ',
        embarcadorTelefone: 'Emitente - Telefone',
        embarcadorBairro: 'Emitente - Bairro',
        embarcadorMunicipio: 'Emitente - Município',
        embarcadorUf: 'Emitente - UF',
        embarcadorCep: 'Emitente - CEP',
        embarcadorInscricaoEstadual: 'Emitente - Inscrição Estadual',
        embarcadorInscricaoMunicipal: 'Emitente - Inscrição Municipal',
        embarcadorCnaeFiscal: 'Emitente - CNAE Fiscal',
        embarcadorInscricaoEstadualTributario:
          'Emitente - Inscrição Estadual do Substituto Tributário',
        embarcadorMunicipioIcms:
          'Emitente - Município da Ocorrência do Fato Gerador do ICMS',
        embarcadorEndereco: 'Emitente - Endereço completo',
        destinatario: 'Destinatário',
        embarcadorRazaoSocialAlt: 'Razão Social',
        destinatarioRazaoSocial: 'Destinatário - Razão Social',
        destinatarioCpfCnpj: 'Destinatário - CPF/CNPJ',
        destinatarioTelefone: 'Destinatário - Telefone',
        destinatarioTelefoneAlt: 'Telefone do Destinatário',
        destinatarioBairro: 'Destinatário - Bairro',
        destinatarioMunicipio: 'Destinatário - Município',
        destinatarioUf: 'Destinatário - UF',
        destinatarioCep: 'Destinatário - CEP',
        destinatarioIndicadorIe: 'Destinatário - Indicador IE',
        destinatarioIm: 'Destinatário - IM',
        destinatarioInscricaoEstadual: 'Destinatário - Inscrição Estadual',
        destinatarioInscricaoSuframa: 'Destinatário - Inscrição SUFRAMA',
        destinatarioEmail: 'Destinatário - E-mail',
        destinatarioEndereco: 'Destinatário - Endereço',
        transportador: 'Transportador',
        transportadorRazaoSocial: 'Transportador - Razão Social',
        transportadorCpfCnpj: 'Transportador - CPF/CNPJ',
        transportadorTelefone: 'Transportador - Telefone',
        transportadorBairro: 'Transportador - Bairro',
        transportadorMunicipio: 'Transportador - Município',
        transportadorUf: 'Transportador - UF',
        transportadorCep: 'Transportador - CEP',
        auditoria: 'Auditoria',
        auditoriaStatus: 'Auditoria - Status',
        auditoriaDataCriacao: 'Auditoria - Data de criação',
        auditoriaResponsavel: 'Auditoria - Responsável',
        auditoriaMotivo: 'Auditoria - Motivo para não conforme',
        auditoriaDataCanhoto: 'Auditoria - Data da assinatura do canhoto',
        auditoriaObservacao: 'Auditoria - Observações',
        conform: 'Conforme',
        disapprove: 'Não conforme',
        endereco: 'Endereço de Entrega',
        addressOption: 'Opção de endereço',
        motorista: 'Entregador',
        motoristaVersaoApp: 'Versão do app',
        motoristaMarca: 'Marca do aparelho',
        motoristaModelo: 'Modelo do aparelho',
        tipoOcorrencia: 'Descrição da ocorrência',
        tentativa: 'Tentativas',
        tentativaAlt: 'Tentativa de Entrega',
        nroFotosOcorrencia: 'Fotos ocorrência',
        nroFotosOcorrenciaAlt: 'Quantidade de fotos de ocorrências',
        nroComprovantes: 'Comprovantes',
        nroComprovantesAlt: 'Quantidade de fotos de comprovantes',
        tempoCheckin: 'Tempo de Espera (Checkin)',
        tempoEntrega: 'Tempo de entrega',
        event: 'Ocorrência',
        eventAlt: 'Tipo de ocorrência',
        eventReason: 'Descrição da ocorrência',
        posicaoMotorista: 'Posição do entregador',
        responsavelFilial1: 'Responsável Filial 1',
        responsavelFilial2: 'Responsável Filial 2',
        sistema3: 'Sistema 3',
        sistema4: 'Sistema 4',
        statusCarga: 'Status',
        idCargaPk: 'ID',
        type: 'Tipo',
        danfe: 'Danfe',
        danfeAlt: 'Danfe',
        comDanfe: 'COM Danfe',
        semDanfe: 'SEM Danfe',
        nroNotaFiscal: 'Nota fiscal',
        nroNotaFiscalAlt: 'NF/Documento',
        embarcadorCpfCnpjAlt: 'CPF / CNPJ - Emitente',
        cpfCnpjDestinatario: 'CPF/CNPJ',
        nomeDestinatario: 'Nome Destinatário',
        dataInicioEntrega: 'Data/hora início da entrega',
        dataInicioEntregaAlt: 'Início da Entrega',
        dataFinalizacao: 'Data/hora entrega',
        dataCriacao: 'Data/hora criação',
        dataInclusao: 'Data de inclusão',
        dataCriacaoAlt: 'Data de Criação',
        tipoPessoaRecebedor: 'Tipo de Recebedor',
        tipoPessoaRecebedorAlt: 'Tipo de recebedor',
        qtdPaleteEntregue: 'Quant. Paletes ou Outras Embalagens Entregues',
        qtdPaleteEntregueAlt: 'Paletes ou Outras Embalagens Entregues',
        qtdPaleteRetirado: 'Quant. Paletes ou Outras Embalagens Retiradas',
        qtdPaleteRetiradoAlt: 'Paletes ou Outras Embalagens Retiradas',
        observacao: 'Observação',
        observacaoColeta: 'Observação Coleta',
        pontoReferenciaEntrega: 'Orientação da entrega',
        auditoriaLocalEntrega: 'Auditoria de Local - Entrega',
        mapLinkDelivery: 'Mapa Entregue',
        auditoriaLocalCheckIn: 'Auditoria de Local - Checkin',
        mapLinkCheckIn: 'Mapa Checkin',
        latitude: 'Latitude',
        longitude: 'longitude',
        latitudeEntrega: 'Latitude da entrega',
        latitudeEntregaAlt: 'Latitude Entregue',
        longitudeEntrega: 'Longitude da entrega',
        longitudeEntregaAlt: 'Longitude Entregue',
        nomeRecebedor: 'Nome completo do recebedor',
        nomeRecebedorAlt: 'Recebedor',
        documentoRecebedor: 'CPF/CNPJ do recebedor',
        documentoRecebedorAlt: 'CPF Recebedor',
        devolvida: 'Devolvida',
        rgRecebedor: 'RG do recebedor',
        rgRecebedorAlt: 'RG Recebedor',
        ativo: 'Ativo',
        idCargaApp: 'ID Carga App',
        latitudeCheckIn: 'Latitude check-in',
        latitudeCheckInAlt: 'Latitude Checkin',
        longitudeCheckIn: 'Longitude check-in',
        longitudeCheckInAlt: 'Longitude Checkin',
        dataCheckIn: 'Data/hora check-in',
        dataCheckInAlt: 'Checkin',
        dataEmissaoDanfe: 'Data de Emissão da DANFE',
        checkListComponentes: 'Checklist - Componentes',
        checkListAtendente: 'Checklist - Atendimento',
        dataEmissaoDanfeAlt: 'Data de Emissão da DANFE',
        dataPrevisao: 'Previsão da entrega',
        dataPrevisaoAlt: 'Data/Hora Prevista',
        slaStatus: 'SLA (status)',
        slaDias: 'SLA (dias)',
        slaDiasReal: 'SLA real (dias)',
        slaStatusPendente: 'SLA (status pendente)',
        slaStatusFinalizado: 'SLA (status finalizado)',
        codigoBarra: 'Código de Barras',
        possuiDanfe: 'Possui danfe',
        placaVeiculo: 'Placa do veículo',
        placaVeiculoAlt: 'Placa de Veículo',
        tipoVeiculo: 'Tipo do veículo',
        tipoVeiculoAlt: 'Tipo de Veículo',
        nomeMotorista: 'Nome do entregador',
        nomeEmbarcador: 'Embarcador',
        idResponsavelCriadorFk: 'ID Responsavel Criador',
        criadoViaPainel: 'Criado via painel',
        idMotoristaCriadorFk: 'ID Motorista Criador',
        serialNumber: 'Número de Série',
        cte: 'CTE',
        nroCte: 'Número CTE',
        nroCteAlt: 'CTE',
        pedido: 'Pedido',
        outroDocumentoRecebedor: 'Outro Documento',
        distanciaParaDestinoEmMetros: 'Distância para o Destino',
        duracaoParaDestinoEmSegundos: 'Tempo Estimado para o Destino',
        protocolSsw: 'Protocol SSW',
        criadoVia: 'Criado via',
        finalizadoVia: 'Finalizado via',
        criadoPorNomeRazaoSocial: 'Criador por - Nome/Razão Social',
        criadoPorCpfCnpj: 'Criado por - CPF/CNPJ',
        finalizadoViaAlt: 'Baixa',
        finalizadoViaWeb: 'Finalizado via',
        dataBaixaSistema: 'Data/hora baixa do sistema',
        dataBaixaSistemaAlt: 'Data/Hora da baixa',
        dataRemocao: 'Data/hora remoção',
        distanciaCheckInEmMetros: 'Distância do check-in em metros',
        distanciaEntregaEmMetros: 'Distancia da entrega em metros',
        reprocessarRedesul: 'Reprocessar Redesul',
        idEmbarcadorCacheFk: 'ID Embarcador Cache',
        idTransportadorCacheFk: 'ID Transportador Cache',
        compartilhar: 'Compartilhar',
        mesEntrega: 'Mes da Entrega',
        sigla: 'Sigla',
        idEnderecoFk: 'ID Endereço',
        idMotoristaFk: 'ID Motorista',
        idOcorrenciaFk: 'ID Ocorrencia',
        idUltimaPosicaoMotoristaFk: 'ID Última Posição Entregador',
        idSistemaCriadorFk: 'ID Sistema Criador',
        idSistemaFinalizadorFk: 'ID Sistema Finalizador',
        idSistemaRemovedorFk: 'ID Sistema Removedor',
        idRemovedorFk: 'ID Removedor',
        idUltimaAuditoriaFk: 'ID Ultima Auditoria',
        idFilialEmbarcadorFk: 'ID Filial Embarcador',
        idFilialTransportadorFk: 'ID Filial Transportador',
        idStatusFk: 'ID Status',
        motoristaCel: 'Telefone do Motorista',
        receiverCel: 'Telefone do Destinatário',
        baixaViaWeb: 'Baixa via portal',
        xpedido: 'Número do Pedido',
        centroDeCusto: 'Centro de Custo',
        transportadorEnd: 'Endereço Transportador',
        horarioChegadaObra: 'Horário Chegada na Obra',
        horarioSaidaObra: 'Horário Saida da Obra',
        horarioChegadaCentral: 'Horário Chegada na Central',
        horarioInicioDescarga: 'Horário Inicio Descarga',
        horarioTerminoDescarga: 'Horário Término Descarga',
        contrato: 'Contrato',
        manifesto: 'Manifesto',
        placaVeiculoPopOverAlt: 'Placa do Veículo',
        placaVeiculoPopOverAltMessage: 'Placa do cadastro do motorista',
        tipoOcorrenciaSucesso: 'Tipo de Finalização com Sucesso',
        listaDeAvarias: 'Lista de Avarias',
        cdCorreio: 'Código Correios',
        diasAtraso: 'Dias em atraso',
        slaByDiasAtraso: 'Sla Status',
        notificacaoSmsAtlas: 'Notificação SMS',
        notificacaoEntrega: 'Observação da Entrega',
        notificacaoEmailAtlas: 'Notificação E-Mail',
        nroCteRenamedAsCte: 'CTE',
        dataPrevisaoAtualizada: 'Previsão de entrega alterada',
        dataPrevisaoAtualizadaAlt: 'Previsão Atualizada',
        observacaoPrevisao: 'Descrição/Motivo da alteração',
        observacaoEntrega: 'Observação da Entrega',
        dataPrevisaoAtualizadaPublic: 'Previsão de entrega alterada',
        lastUpdate: 'Último geoposicionamento do entregador',
      },
    },
    CargaTransfolha: {
      title: 'Carga Transfolha',
      columns: {
        carga: 'Carga',
        idCargaTransfolhaPk: 'Id Carga Transfolha Pk',
        pedido: 'Pedido',
        idCargaFk: 'Id Carga Fk',
      },
    },
    ResponseRobo: {
      title: 'Response Robo',
      columns: {
        idResponsePk: 'Id Response Pk',
        danfe: 'Danfe',
        response: 'Response',
      },
    },
    Sistema: {
      title: 'Sistema',
      columns: {
        idSistemaPk: 'Id Sistema Pk',
        nome: 'Nome',
        ativo: 'Ativo',
      },
    },
    ReponsavelAssociado: {
      title: 'Reponsavel Associado',
      columns: {
        responsavel: 'Responsavel',
        idAssociadoPk: 'Id Associado Pk',
        razaoSocial: 'Razão Social',
        nomeFantasia: 'Nome Fantasia',
        cnpj: 'Cnpj',
        senha: 'Senha',
        ativo: 'Ativo',
        idResponsavelFk: 'Id Responsavel Fk',
      },
    },
    ResponsavelFilial: {
      title: 'Responsavel Filial',
      columns: {
        idFilialPk: 'Id Filial Pk',
        cnpjBase: 'Cnpj Base',
      },
    },
    ResponsavelSaraiva: {
      title: 'Responsavel Saraiva',
      columns: {
        responsavel: 'Responsavel',
        idResponsavelSaraivaPk: 'Id Responsavel Saraiva Pk',
        idResponsavelFk: 'Id Responsavel Fk',
      },
    },
    ResponseRoboCnpj: {
      title: 'Response Robo Cnpj',
      columns: {
        idResponsePk: 'Id Response Pk',
        cnpj: 'Cnpj',
        response: 'Response',
      },
    },
    CargaDestinatario: {
      title: 'Carga Destinatario',
      columns: {
        carga: 'Carga',
        endereco: 'Endereço',
        nome: 'Nome/Razão Social',
        cpfCnpj: 'CPF/CNPJ',
        telefone: 'Telefone',
        indicadorIe: 'Indicador Ie',
        inscricaoEstadual: 'Inscricao Estadual',
        inscricaoSuframa: 'Inscricao Suframa',
        im: 'Im',
        email: 'E-Mail',
        idEnderecoFk: 'Id Endereco Fk',
        idCargaFk: 'Id Carga Fk',
      },
    },
    Banner: {
      title: 'Banner',
      columns: {
        idBannerPk: 'Id Banner Pk',
        nome: 'Nome',
        dataInicio: 'Data Inicio',
        dataFim: 'Data Fim',
        urlImagem: 'Url Imagem',
        urlRedirect: 'Url Redirect',
        dataCriacao: 'Data Criacao',
        ativo: 'Ativo',
      },
    },
    StatusSms: {
      title: 'Status Sms',
      columns: {
        idStatusPk: 'Id Status Pk',
        nome: 'Nome',
        ativo: 'Ativo',
      },
    },
    BaseFretebas: {
      title: 'Base Fretebas',
      columns: {
        idFretebasPk: 'Id Fretebas Pk',
        carga: 'Carga',
        preco: 'Preco',
        veiculos: 'Veiculos',
        carroceria: 'Carroceria',
        km: 'Km',
        especie: 'Especie',
        complemento: 'Complemento',
        rastreamento: 'Rastreamento',
        obs: 'Obs',
        nextel: 'Nextel',
        celular: 'Celular',
        fone: 'Fone',
        whatsup: 'Whatsup',
        sac: 'Sac',
        response: 'Response',
        nome: 'Nome',
        origem: 'Origem',
        destino: 'Destino',
      },
    },
    Endereco: {
      title: 'Endereço',
      columns: {
        idEnderecoPk: 'ID',
        logradouro: 'Logradouro',
        nro: 'Número',
        bairro: 'Bairro',
        cep: 'CEP',
        cidade: 'Cidade',
        uf: 'UF',
        latitude: 'Latitude',
        longitude: 'Longitude',
        complemento: 'Complemento',
        pais: 'País',
        fillNro: 'Preencha o número e o complemento',
      },
    },
    CargaOpenlog: {
      title: 'Carga Openlog',
      columns: {
        carga: 'Carga',
        idCodigoPk: 'Id Codigo Pk',
        idPedido: 'Id Pedido',
        idCargaFk: 'Id Carga Fk',
      },
    },
    CargaResponsavel: {
      title: 'Carga Responsavel',
      columns: {
        carga: 'Carga',
        endereco: 'Endereço',
        responsavel: 'Responsavel',
        responsavelFilial: 'Responsavel Filial',
        ehEmbarcador: 'Eh Embarcador',
        inscricaoEstadual: 'Inscricao Estadual',
        substitutoTributario: 'Substituto Tributario',
        inscricaoMunicipal: 'Inscricao Municipal',
        municipioIcms: 'Municipio Icms',
        cnaeFiscal: 'Cnae Fiscal',
        codigoRegimeTributario: 'Codigo Regime Tributario',
        idEnderecoFk: 'Id Endereco Fk',
        idFilialFk: 'Id Filial Fk',
        idResponsavelFk: 'Id Responsavel Fk',
        idCargaFk: 'Id Carga Fk',
        nome: 'Razão Social',
        cnpj: 'CNPJ',
        telefone: 'Telefone',
        email: 'E-Mail',
      },
    },
    ResponsavelHistoricoSms: {
      title: 'Responsavel Historico Sms',
      columns: {
        idHistoricoPk: 'Id Historico Pk',
        idResponsavelFk: 'Id Responsavel Fk',
        idCargaFk: 'Id Carga Fk',
        nomeDestinatario: 'Nome Destinatario',
        nfe: 'Nfe',
        mensagem: 'Mensagem',
        dataEnvio: 'Data Envio',
        telefone: 'Telefone',
        idTypeFk: 'Id Type Fk',
      },
    },
    CockpitRequest: {
      title: 'Cockpit Request',
      columns: {
        period: 'Período',
        hour: 'Hora',
        day: 'Dia',
        month: 'Mês',
        year: 'Ano',
        date: 'Data',
        uf: 'UF',
        region: 'Região',
        sigla: 'Sigla',
        cidade: 'Cidade',
        groupedBy: 'Agrupamento',
        documentResponsavel: 'CPF/CNPJ Embarcador Transportador',
        documentResponsavel2: 'CPF/CNPJ Transportador',
        documentDestinatario: 'CPF/CNPJ Destinatário',
        allowNotification: 'Allow Notification',
        updateAutomatically: 'Update Automatically',
        ocorrencia: 'Tipo de ocorrência',
        nroNotaFiscal: 'Nota Fiscal',
        manifesto: 'Manifesto',
      },
    },
    CockpitResponse: {
      title: 'Cockpit Response',
      columns: {
        initialized: 'INICIADAS',
        shipping: 'EM ROTA',
        waiting: 'AGUARDANDO ROTA',
        cargaSuccessfullyDelivered: 'SEM OCORRÊNCIA',
        cargaWithOccurrence: 'COM OCORRÊNCIA',
        cargaWithDevolution: 'DEVOLVIDAS',
        total: 'ENTREGAS FINALIZADAS',
        deliveryDay: 'Entregas do dia {date}',
        deliveryDelayedDay: 'Entregas por origem pendentes até {date}',
        deliveryDelayedTransporterDay: 'Entregas pendentes até {date}',
        deliveryMonth: 'Entregas do mês de {month} de {year}',
        deliveryYear: 'Entregas do ano de {year}',
        checkUpdateDate: 'Última atualização: {date}',
        automaticUpdate: 'Atualização automática a cada 30 min',
      },
    },
    CockpitPerformanceResponse: {
      title: 'Cockpit Performance Response',
      columns: {
        origin: 'Origem',
        started: 'Iniciadas',
        inRoute: 'Em Rota',
        waiting: 'Aguardando Rota',
        total: 'Total',
      },
    },
    CockpitPerformancePorDataResponse: {
      title: 'Cockpit Performance Por Data Response',
      columns: {
        delayedPre: 'Entregas pendentes por vencimento',
        delayed: 'Em Atraso',
        noPreview: 'Sem data previsão',
        delivered: 'Entregues',
        pending: 'Pendentes',
        description: 'Data de Previsão de Entrega em',
        total: 'Total',
        todaySemDataPrevisao: 'Sem data previsão',
        todayForaDoPrazo: 'Fora do prazo',
        todayNoPrazo: 'No prazo',
      },
    },
    TrackingRequest: {
      title: 'Tracking Request',
      columns: {
        otherResponsible: 'CNPJ do outro responsável',
        currentNroFiscal: 'Consulta Por Nota Fiscal',
        showing: 'Exibição',
        driver: 'Entregador',
        uf: 'UF',
        region: 'Região',
        sigla: 'Sigla',
        cidade: 'Cidade',
        invoiceNumber: 'Invoice Number',
        documentResponsavel: 'CPF/CNPJ Embarcador/Transportador',
        allDrivers: 'Todos os entregadores',
        allResponsibles: 'Todos os CNPJ',
        centroDeCusto: 'Centro de custo',
        auditoriaMotivo: 'Motivo de Auditoria',
        documentDestinatario: 'CPF/CNPJ Destinatário',
        transferenciaDistribuicao: 'NF/Cte é Transferência ou Distribuição',
        criadoVia: 'Criado via',
        groupedBy: 'Agrupamento',
        sistemaCriador: 'Sistema Criador',
        tipoInsumo: 'Tipo insumo',
        cte: 'CTE',
        manifesto: 'Manifesto',
        placa: 'Placa do Veículo',
        placaVeiculoTip: 'A placa apresentada é a placa do perfil do motorista',
        nomeDestinatario: 'Consulta por Nome do Destinatário',
        nomeDestinatarioAlt: 'Nome do Destinatário',
      },
    },
    TrackingResponse: {
      title: 'Tracking Response',
      columns: {
        initialized: 'INICIADAS',
        shipping: 'EM ROTA',
        waiting: 'AGUARDANDO ROTA',
        cargaSuccessfullyDelivered: 'SEM OCORRÊNCIA',
        cargaWithOccurrence: 'COM OCORRÊNCIA',
        cargaWithDevolution: 'DEVOLVIDAS',
        total: 'ENTREGAS FINALIZADAS',
        deliveryDay: 'Entregas do dia {date}',
        deliveryMonth: 'Entregas do mês de {month} de {year}',
        deliveryYear: 'Entregas do ano de {year}',
      },
    },
    DeliveryRequest: {
      title: 'Delivery Request',
      columns: {
        startDate: 'Data de início (criação de carga)',
        endDate: 'Data de fim (criação de carga)',
        motorista: 'Entregador',
        status: 'Status',
        event: 'Ocorrência',
        audit: 'Auditoria',
        auditGeo: 'Auditoria Geo',
        auditReason: 'Motivo de Auditoria',
        docs: 'Consulta por nota fiscal',
        slaStatus: 'Filtro SLA',
        driverStatus: 'Filtro entregador',
        docsPlaceholder:
          'Use vírgula para mais de uma NF. Ex: 1234, 3321, 1234',
        documentResponsavel: 'CPF/CNPJ Embarcador/Transportador',
        documentDestinatario: 'CPF/CNPJ Destinatário',
        cep: 'CEP',
        cepInicial: 'CEP Inicial',
        cepFinal: 'CEP Final',
        cidade: 'Cidade',
        uf: 'UF',
        cte: 'CTE',
        ocorrencia: 'Tipo de ocorrência',
        centroDeCusto: 'Centro de Custo',
        sistemaFinalizador: 'Sistema Finalizador',
        sistemaCriador: 'Sistema Criador',
        auditAccording: 'Auditoria Geolocalização',
        sigla: 'Sigla',
        tipoInsumo: 'Tipo insumo',
        consultaCTE: 'Consulta por CTE',
        consultaCTEPlaceholder:
          'Use vírgula para mais de um CTE. Ex: 1234, 3321, 1234',
        cleanCTE: 'Limpar CTEs',
        dataEntregaInicio: 'Data de início (Data/hora entrega)',
        dataEntregaFim: 'Data de fim (Data/hora entrega)',
        dataPrevisaoInicio: 'Data de inicio (Previsão de entrega)',
        dataPrevisaoFim: 'Data de fim (Previsão de entrega)',
        placaVeiculo: 'Placa do Veículo',
        placaVeiculoTip: 'A placa apresentada é a placa do perfil do motorista',
      },
    },
    ClientNotificationRequest: {
      title: 'Delivery Request',
      columns: {
        startDate: 'Data de início (criação de carga)',
        endDate: 'Data de fim (criação de carga)',
        notification: 'Notificação',
        documentDestinatario: 'CPF/CNPJ Destinatário',
        documentResponsavel: 'CPF/CNPJ Embarcador/Transportador',
        docs: 'Consulta por Nota Fiscal',
        consultaCTE: 'Consulta por CTE',
        manifesto: 'Manifesto',
      },
    },
    DeliveryPeriodRequest: {
      title: 'Delivery Period Request',
      columns: {
        startDate: 'Período inicial',
        endDate: 'Período final',
      },
    },
    DeliveryPeriodResponse: {
      title: 'Delivery Period Request',
      columns: {
        mes: 'Mês',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
      },
    },
    DeliveryMonthRequest: {
      title: 'Delivery Month Request',
      columns: {
        date: 'Mês/Ano',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
      },
    },
    DeliverySlaRequest: {
      title: 'Delivery Month Request',
      columns: {
        startDate: 'De',
        endDate: 'Até',
        uf: 'UF',
        region: 'Região',
        city: 'Cidade',
        sigla: 'Sigla',
        documentResponsavel: 'CPF/CNPJ Embarcador/Transportador',
        slaStatus: 'Filtro SLA',
        tipoInsumo: 'Tipo Insumo',
        idTipoCriacao: 'Sistema Finalizador',
        idTipoFinalizacao: 'Sistema Criador',
        documentoDestinatario: 'CPF/CNPJ Destinatário',
      },
    },
    DeliverySlaResponse: {
      title: 'Delivery Month Request',
      columns: {
        nome: 'Embarcador/Transportador',
        documento: 'CNPJ Embarcador/Transp',
        naoInformadoSLA: 'SLA Não Informado',
        foraSLA: 'Fora do SLA',
        dentroSLA: 'Dentro do SLA',
        porcentagemDentroSLA: '%',
        porcentagemForaSLA: '%',
        porcentagemNaoInformadoSLA: '%',
      },
    },
    ClientNotificationResponse: {
      title: 'Notificação do Cliente',
      columns: {
        idCargaPk: 'ID',
        nroNotaFiscal: 'Nota Fiscal',
        notificacao: 'Notificação',
        observacaoEntrega: 'Observação da Entrega',
        dataCriacao: 'Data/Hora Criação',
        nomeDestinatario: 'Destinatário',
        docDestinatario: 'Destinatário - CPF/CNPJ',
        nomeTransportador: 'Transportador',
        docTransportador: 'Transportador - CPF/CNPJ',
      },
    },
    ClientNotificationResponseCSV: {
      title: 'Notificação do Cliente',
      columns: {
        idCargaPk: 'ID',
        nroNotaFiscal: 'NF/Documento',
        notificacao: 'Notificação',
        observacaoEntrega: 'Observação da Entrega',
        dataCriacao: 'Data de Criação',
        nomeDestinatario: 'Destinatário - Razão Social',
        docDestinatario: 'Destinatário - CPF/CNPJ',
        nomeTransportador: 'Transportador - Razão Social',
        docTransportador: 'Transportador - CPF/CNPJ',
      },
    },
    DeliveryCanceledRequest: {
      title: 'Delivery Canceled Request',
      columns: {
        motorista: 'Entregador',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        docs: 'Consulta por nota fiscal',
        docsPlaceholder:
          'Use vírgula para mais de uma NF. Ex: 1234, 3321, 1234',
        consultaCTE: 'Consulta CTE',
        consultaCTEPlaceholder: 'Use vírgula para mais de um CTE. Ex: 1234, 3321, 1234',
      },
    },
    DeliveryAlertHistoryRequest: {
      title: 'Delivery Alert History Request',
      columns: {
        motorista: 'Entregador',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
      },
      docs: 'Consulta por Nota Fiscal',
      docsPlaceholder: 'Use vírgula para mais de uma NF. Ex: 1234, 3321, 1234',
    },
    DeliverySatisfactionSurveyHistoryRequest: {
      title: 'Delivery Satisfaction Survery History Request',
      columns: {
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
      },
    },
    DeliveryCanceledResponse: {
      title: 'Delivery Canceled Response',
      columns: {
        id: 'ID',
        idCarga: 'ID Carga',
        nome: 'Responsável pelo Cancelamento',
        cpfMotorista: 'Documento do Cancelador',
        nfCarga: 'NF Carga',
        danfeCarga: 'Danfe Carga',
        dataCriacao: 'Data Criação',
        data: 'Data',
        justificativa: 'Justificativa',
        manifesto: 'Manifesto',
        nroCteAlt: 'CTE',
        nroCTE: 'Número CTE',
      },
    },
    DeliveryAlertHistoryResponse: {
      title: 'Delivery Alert History Response',
      columns: {
        id: 'ID',
        mensagem: 'Detalhe',
        documento: 'NF Carga',
        motorista: 'Motorista',
        data: 'Data',
      },
    },
    DeliverySatisfactionSurveyHistoryResponse: {
      title: 'Delivery Satisfaction Survey History Response',
      columns: {
        id: 'ID',
        documento: 'NF Carga',
        notaPergunta1: 'Nota da pergunta 1',
        notaPergunta2: 'Nota da pergunta 2',
        notaPergunta1Alt: 'Nota da pergunta 1',
        notaPergunta2Alt: 'Nota da pergunta 2',
        imgUrl: 'Foto silenciosa',
        imgUrlAlt: 'Foto silenciosa',
        data: 'Data',
        pergunta1: 'Pergunta 1',
        pergunta2: 'Pergunta 2',
        documentoRecebedor: 'Documento do Recebedor',
        nomeMotorista: 'Nome do Entregador',
        razaoSocial: 'Nome do Transportador',
        cpfMotorista: 'Documento Entregador',
        nomeRecebedor: 'Nome do Recebedor',
        xpedido: 'Numero do Pedido',
        danfe: 'Danfe',
      },
    },
    DeliveryReceiverRequest: {
      title: 'Delivery Receiver Request',
      columns: {
        cnpj: 'CNPJ da Transportadora',
        transportadora: 'Destinatário',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
      },
    },
    DeliveryReceiverResponse: {
      title: 'Delivery Receiver Response',
      columns: {
        id: 'ID',
        nome: 'Nome Destinatário',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrência',
        qtdComOcorrencia: 'Entregas com Ocorrência',
        qtdDevolvidas: 'Devolvidas',
        documento: 'CPF/CNPJ',
      },
    },
    DeliveryUfResponse: {
      title: 'Delivery Uf Response',
      columns: {
        nome: 'UF',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
      },
    },
    DeliveryUfRequest: {
      title: 'Delivery Uf Request',
      columns: {
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        uf: 'UF',
        allUf: 'Todas as UF',
      },
    },
    DeliverySacResponse : {
      title: 'SAC Relatório',
      columns: {
        nroNotaFiscal: 'Nota fiscal',
        dataPrevisao: 'Previsão de Entrega',
        danfe: 'Danfe',
        attempt: 'Tentativa',
        status: 'Status',
        event: 'Evento',
        date: 'Data',
        shipperName: 'Transportador',
        manifest: 'Manifesto',
        nroCTE: 'Número CTE',
        dataPrevisaoAtualizada: 'Previsão de entrega alterada',
        observacaoPrevisao: 'Descrição/Motivo da alteração',
      },
    },
    DeliveryVehicleResponse: {
      title: 'Delivery Vehicle Response',
      columns: {
        nome: 'Tipo Veículo',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
        qtdTotal: 'Quantidade de Entregas',
      },
    },
    DeliveryVehicleRequest: {
      title: 'Delivery Vehicle Request',
      columns: {
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        veiculo: 'Veículo',
        allVehicles: 'Todos os Veículos',
      },
    },
    DeliveryTrackingRequest: {
      title: 'Delivery Tracking Request',
      columns: {
        motorista: 'Entregador',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
        auditGeo: 'Auditoria Geo',
      },
    },
    DeliveryTrackingResponse: {
      title: 'Delivery Tracking Response',
      columns: {
        ultimaData: 'Fim da Jornada',
        primeiraData: 'Inicio da Jornada',
        nome: 'Motorista',
      },
    },
    DeliveryDriverRequest: {
      title: 'Delivery Driver Request',
      columns: {
        entregador: 'Entregador',
        dia: 'Dia',
        mes: 'Mês',
        ano: 'Ano',
      },
    },
    DeliveryDriverResponse: {
      title: 'Delivery Driver Response',
      columns: {
        id: 'ID',
        nome: 'Nome do Entregador',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
        documento: 'CPF/CNPJ',
        placa: 'Placa',
      },
    },
    DeliveryMonthResponse: {
      title: 'Delivery Driver Response',
      columns: {
        data: 'Mês/ano',
        id: 'ID',
        nome: 'Nome do Entregador',
        qtdTotal: 'Quantidade de Entregas',
        qtdSemOcorrencia: 'Entregas sem Ocorrências',
        qtdComOcorrencia: 'Entregas com Ocorrências',
        qtdDevolvidas: 'Devolvidas',
      },
    },
    DeliveryAuditRequest: {
      title: 'Delivery Driver Response',
      columns: {
        from: 'De',
        to: 'Até',
        uf: 'UF',
        region: 'Região',
        sigla: 'Sigla',
        cidade: 'Cidade',
        cnpjEmbarcadorTransportador: 'CPF/CNPJ Embarcador/Transportador',
        documentoDestinatario: 'CPF/CNPJ Destinatário',
      },
    },
    DeliveryAuditResponse: {
      title: 'Delivery Driver Response',
      columns: {
        entregaNaoInformado: 'Entrega Não Informado',
        entregaNaoConforme: 'Entrega Não Conforme',
        entregaConforme: 'Entrega Conforme',
        checkinConforme: 'CheckIn Conforme',
        checkinNaoConforme: 'CheckIn Não Conforme',
        checkinNaoInformado: 'CheckIn Não Informado',
        documento: 'CNPJ Embarcador/Transp',
        nome: 'Embarcador/Transp',
      },
    },
    DeliverySacRequest: {
      title: 'Delivery SAC Request',
      columns: {
        documentDestinatario: 'Documento',
        cte: 'CTE',
        documentDestinatarioPlaceholder: 'DANFE, CNPJ ou CPF do destinatário',
        docs: 'Consulta por Nota Fiscal',
        searchByCte: 'Consulta por CTE',
        docsPlaceholder:
          'Use vírgula para mais de uma NF. Ex: 1234, 3321, 1234',
        typeOccurence: 'Tipo de ocorrência',
        occurrenceTracking: 'Ocorrência Tracking',
        tipoInsumo: 'Tipo insumo',
        consultaCTE: 'Consulta por CTE',
        consultaCTEPlaceholder:
          'Use vírgula para mais de um CTE. Ex: 1234, 3321, 1234',
        cleanCTE: 'Limpar CTEs',
      },
    },
    DeliverySacRequestGuest: {
      title: 'Delivery SAC Request Guest',
      columns: {
        danfe: 'Número da Danfe (44 dígitos)',
        nroFiscal: 'Números da Nota Fiscal',
        nroCorreios: 'Cód. Rastreamento Correios (13 dígitos)',
        nroPedido: 'Número do Pedido da Compra',
        cte: 'Número do CTe (44 dígitos)',
        cpfCnpj: 'CPF ou CNPJ do destinatário',
      },
    },
    DeliverySacAttemptResponse: {
      title: 'SAC Público CNPJ/CPF',
      columns: {
        nomeRazaoDestinatario: 'Destinatário - Nome/Razão Social',
        cpfCnpjDestinatario: 'Destinatário - CPF/CNPJ',
        telefoneDestinatario: 'Destinatário - Telefone',
        emailDestinatario: 'Destinatário - E-mail',
        enderecoDestinatario: 'Destinatário - Endereço',
        nomeTransportador: 'Transportador - Razão Social',
        cnpjTransportador: 'Transportador - CNPJ',
        nomeEmbarcador: 'Embarcador - Razão Social',
        cnpjEmbarcador: 'Embarcador - CNPJ',
        nroNotaFiscal: 'Nota Fiscal',
        nroCTE: 'Número de CTE',
        dataPrevisao: 'Previsão de entrega',
        attempt: 'Tentativa de Visita',
        status: 'Status',
        event: 'Evento',
        data: 'Data',
        },
    },
    SacResponse: {
      title: 'SAC Response',
      columns: {
        attempt: 'Tentativa',
        type: 'Tipo',
        status: 'Status',
        event: 'Evento',
        date: 'Data',
        shipperName: 'Transportador',
      },
    },
    ManageDriverList: {
      title: 'Delivery Uf Request',
      columns: {
        mes: 'Mês',
        ano: 'Ano',
        uf: 'UF',
        allUf: 'Todas as UF',
      },
    },
    ResetPasswordRequest: {
      columns: {
        email: 'E-mail',
      },
    },
    RotaSla: {
      columns: {
        origem: 'Origem',
        destino: 'Destino',
      },
    },
    RelatorioGeracao: {
      title: 'Relatórios Gerados',
      columns: {
        idRelatorioGeracaoPk: 'ID',
        dataCriacao: 'Data de Requisição',
        dataInicio: 'Data de Início',
        dataFim: 'Data de Fim',
        arquivoSolicitado: 'Arquivo Solicitado',
        dataGeracaoRelatorio: 'Data de Geração',
        urlDownload: 'URL para Download',
      },
    },
    ResponsavelUsuario: {
      title: 'Usuário',
      columns: {
        idUsuarioPk: 'ID',
        role: 'Tipo de usuário',
        defaultAccess: 'Acesso Padrão',
        queryAccess: 'Acesso de Consulta',
        permissao: 'Menus de acesso',
        nome: 'Nome',
        email: 'Email',
        senha: 'Senha',
        ativo: 'Ativo',
      },
    },
    CargaConcreto: {
      title: 'Carga Concreto',
      columns: {
        idCargaConcretoPk: 'ID Carga Cocreto',
        idCargaFk: 'ID da Carga',
        contrato: 'Contrato',
        descricaoProduto: 'Descrição do Produto',
        usina: 'Usina',
        horarioChegadaObra: 'Horário Chegada na Obra',
        horarioInicioDescarga: 'Horário Inicio Descarga',
        horarioTerminoDescarga: 'Horário Término Descarga',
        adicaoAgua: 'Adição Água',
        retornoConcreto: 'Retorno do Concreto',
        horarioSaidaObra: 'Horário Saida da Obra',
        horarioChegadaCentral: 'Horário Chegada na Central',
        hodometroInicial: 'Hodômetro Inicial',
        hodometroFinal: 'Hodômetro Final',
      },
    },
    OcultarNotasResponsavel: {
      title: 'Ocultar Notas do Transportador',
      columns: {
        idOcultarNotasResponsavelPk: 'id Ocultar Notas Responsavel Pk',
        cnpj: 'CNPJ/CPF',
        razaoSocial: 'Razão Social',
        ativo: 'Ativo',
      },
    },
    EmailAuditoria: {
      title: 'E-mail Auditoria',
      columns: {
        idEmailAuditoriaPk: 'id Email Auditoria Pk',
        email: 'E-mails',
        ativo: 'Ativo',
        idEmailNivelFk: 'Nível do Email',
        nomeGrupo: 'Responsável',
      },
    },
    EmailAuditoriaEnvio: {
        title: 'Aguardando Correção Auditoria',
        columns: {
            idCargaFk: 'ID da Carga',
            emailNivel: 'E-mail Enviado',
            nomeGrupo: 'Responsável',
            nroNotaFiscal: 'Nota Fiscal',
            dataCriacao: 'Data e Hora Criação',
            dataBaixa: 'Data e Hora da Baixa',
            dataEnvio: 'Data Envio E-mail',
            statusAuditoria: 'Motivo de Auditoria',
            idResponsavelFk: 'ID do Responsavel',
        },
        selectToNotify: 'Selecione para notificar',
        notifyAll: 'Notificar todos',
        noGroupSelected: 'Nenhum Grupo Responsável selecionado',
        noCargaSelected: 'Nenhuma Carga selecionado',
        successOnNotify: 'E-mails enviados com sucesso',
    },
      AuditValidation: {
      title: 'Aguardando Validação de Auditoria',
      columns: {
          idCargaFk: 'ID',
          nroNotaFiscal: 'Nota Fiscal',
          nroCte: 'CTE',
          danfe: 'Danfe',
          entregador: 'Entregador',
          placaVeiculo: 'Placa do Veículo',
          transportador: 'Transportador',
          enderecoEntrega: 'Endereço da Entrega',
          dataHoraCriacao: 'Data/Hora Criação',
          dataHoraBaixa: 'Data/Hora Baixa do Sistema',
          dataHoraEntrega: 'Data/Hora Entrega',
          auditoria: 'Auditoria',
          motivoAuditoria: 'Motivo de Auditoria',
          statusNotificacaoAuditoria: 'Status Notificação',
          dataCriacao: 'Data de criação Auditoria',
          responsavelAuditoria: 'Responsável Auditoria',
          observacaoAuditoria: 'Observações Auditoria',
          dataCanhoto: 'Data da assinatura no canhoto Auditoria',

      },
      selectToNotify: 'Selecione para notificar',
      notifyAll: 'Notificar todos',
      noGroupSelected: 'Nenhum Grupo Responsável selecionado',
      noCargaSelected: 'Nenhuma Carga selecionado',
      successOnNotify: 'E-mails enviados com sucesso',
    },
    AreaDeRisco: {
      columns: {
        cepInicial: 'Cep Inicial',
        cepFinal: 'Cep Final',
        ativo: 'Ativo',
        notificarNoApp: 'Notificar no App',
        notificarNoPainel: 'Notificar no Painel',
        cnpj: 'CNPJ',
        dataCadastro: 'Data de Cadastro',
      },
    },
    RiskAreaRequest: {
      columns: {
        cepInicial: 'Cep Inicial',
        cepFinal: 'Cep Final',
      },
    },
    RiskAreaResponse: {
      columns: {
        cnpj: 'CNPJ',
        cepInicial: 'Cep Inicial',
        cepFinal: 'Cep Final',
        ativo: 'Ativo',
        notificarNoApp: 'Notificar no App',
        notificarNoPainel: 'Notificar no Painel',
        dataCadastro: 'Data de Cadastro',
      },
    },
    ConfigNovaSla: {
      columns: {
        ufOrigem: 'UF ORIGEM',
        ufDestino: 'UF DESTINO',
        cidadeOrigem: 'CIDADE ORIGEM',
        cidadeDestino: 'CIDADE DESTINO',
        sla: 'SLA',
        cnpjEmbarcador: 'CPF/CNPJ EMBARCADOR',
        cnpjTransportador: 'CPF/CNPJ TRANSPORTADOR',
        calendarizacao: 'CALENDARIZAÇÃO',
        segunda: 'SEGUNDA',
        terca: 'TERCA',
        quarta: 'QUARTA',
        quinta: 'QUINTA',
        sexta: 'SEXTA',
        sabado: 'SABADO',
        domingo: 'DOMINGO',
      },
    },
    DeliveryCsvNotasEmAtraso: {
      columns: {
        idCargaPk: 'ID Carga',
        dataCriacao: 'Data/Hora Criação',
        dataPrevisao: 'Data/Hora Prevista',
        nroNotaFiscal: 'Nota Fiscal',
        nroCte: 'Número CTE',
        danfe: 'Danfe',
        slaDias: 'SLA Dias',
        slaByDiasAtraso: 'SLA Status',
        diasAtraso: 'Dias em Atraso',
      },
    },
    AuditByDeliveryResponse: {
      columns: {
        idCargaPk: 'ID da Carga',
        nroNotaFiscal: 'Nota Fiscal',
        dataCriacao: 'Data E Hora Criação',
        dataBaixaSistema: 'Data e Hora da Baixa',
        statusAuditoria: 'Auditoria',
        statusNotificacaoAuditoria: 'Status Notificação',
        dataEnvio: 'Data Envio E-mail',
        nomeGrupo: 'Responsável',
        emailEnviado: 'Email Enviado',
        motivoAuditoria: 'Motivo Auditoria',
      },
    },
    AuditByDeliveryRequest: {
      columns: {
        statusNotificacaoAuditoria: 'Status Notificação',
      },
    },
    AuditByDeliveryCsvResponse: {
      columns: {
        idCargaPk: 'ID da Carga',
        nroNotaFiscal: 'Nota Fiscal',
        dataCriacao: 'Data e Hora Criação',
        dataBaixaSistema: 'Data e Hora da Baixa',
        statusAuditoria: 'Auditoria',
        statusNotificacaoAuditoria: 'Status Notificação',
        dataEnvio: 'Data Envio E-mail',
        nomeGrupo: 'Responsável',
        emailEnviado: 'E-mail Enviado',
        motivoAuditoria: 'Motivo de Auditoria',
        notNotified: 'Não Notificado',
        notAudited: 'SEM MOTIVO DE AUDITORIA',
        all: 'Todos',
      },
    },
    DeliverySacAgcoResponse: {
      title: 'SAC AGCO',
      columns: {
        nomeRazaoDestinatario: 'Destinatário - Nome/Razão Social',
        cpfCnpjDestinatario: 'Destinatário - CPF/CNPJ',
        telefoneDestinatario: 'Destinatário - Telefone',
        emailDestinatario: 'Destinatário - E-mail',
        enderecoDestinatario: 'Destinatário - Endereço',
        nomeTransportador: 'Transportador - Razão Social',
        cnpjTransportador: 'Transportador - CNPJ',
        nomeEmbarcador: 'Embarcador - Razão Social',
        cnpjEmbarcador: 'Embarcador - CNPJ',
        nroNotaFiscal: 'Nota Fiscal',
        nroCTE: 'Número de CTE',
        dataPrevisao: 'Previsão de entrega',
        attempt: 'Tentativa de Visita',
        status: 'Status',
        event: 'Evento',
        data: 'Data',
        observacaoEntrega: 'Observação da Entrega',
      },
    },
    SacCnhIveco: {
      columns: {
        startDate: 'Data início (criação da nota)',
        endDate: 'Data fim (criação da nota)',
        razaoSocialTransportador: 'Razão Social do Transportador',
        cnpjTransportador: 'CNPJ do Transportador',
        statusCarga: 'Status da nota',
        slaStatus: 'SLA (Status)',
      },
    },
    DeliverySacCnhIvecoResponse: {
      title: 'SAC CNH/IVECO',
      columns: {
        nomeRazaoDestinatario: 'Destinatário - Nome/Razão Social',
        cpfCnpjDestinatario: 'Destinatário - CPF/CNPJ',
        telefoneDestinatario: 'Destinatário - Telefone',
        emailDestinatario: 'Destinatário - E-mail',
        enderecoDestinatario: 'Destinatário - Endereço',
        nomeTransportador: 'Transportador - Razão Social',
        cnpjTransportador: 'Transportador - CNPJ',
        nomeEmbarcador: 'Embarcador - Razão Social',
        cnpjEmbarcador: 'Embarcador - CNPJ',
        nroNotaFiscal: 'Nota Fiscal',
        nroCTE: 'Número de CTE',
        dataPrevisao: 'Previsão de entrega',
        attempt: 'Tentativa de Visita',
        status: 'Status',
        event: 'Evento',
        data: 'Data',
      },
    },
    AutoCompleteDestinatario: {
      columns: {
        nome: 'NOME',
        cpfCnpj: 'CPF_CNPJ',
        telefone: 'TELEFONE',
        email: 'EMAIL',
        logradouro: 'LOGRADOURO',
        numero: 'NUMERO',
        bairro: 'BAIRRO',
        cep: 'CEP',
        cidade: 'CIDADE',
        complemento: 'COMPLEMENTO' ,
        uf: 'UF',
      },
    },
  },
}
